var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 1920 1080",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "th",
    x1: -2.5186,
    x2: -1.2917,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(98 0 0 -125 1630 135865)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1277B9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DB0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1374.7 527.14 1470.3 680.56 1494.8 605.69",
    fill: "url(#th)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xt",
    x1: -3.0068,
    x2: -1.78,
    y1: 1084.9,
    y2: 1083.7,
    gradientTransform: "matrix(126 0 0 -75 1070 81374)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16C6D6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C0D2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "876.79 76.709 776.33 0 752.39 0 722.28 77.937",
    fill: "url(#xt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ace",
    x1: -4.687,
    x2: -3.4601,
    y1: 1084.6,
    y2: 1083.3,
    gradientTransform: "matrix(77 0 0 -68 1333 74069)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA87D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AC7B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1028.9 307.45 984.71 390.91 1079.1 367.59",
    fill: "url(#ace)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acs",
    x1: -0.8896,
    x2: 0.337,
    y1: 1083.1,
    y2: 1081.8,
    gradientTransform: "matrix(148 0 0 -77 1749 84295)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D0280",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51037B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1581.9 924.8 1763.4 1011.9 1737.6 917.44",
    fill: "url(#acs)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ade",
    x1: -2.6802,
    x2: -1.4534,
    y1: 1081.8,
    y2: 1080.6,
    gradientTransform: "matrix(79 0 0 -135 1966 147070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE08A9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0590",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1763.4 1011.9 1766.5 1080 1803.2 1080",
    fill: "url(#ade)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adp",
    x1: -12.508,
    x2: -11.282,
    y1: 1082.7,
    y2: 1081.4,
    gradientTransform: "matrix(44 0 0 -131 671 142173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B94740",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#934952",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "186.4 448.59 132.44 308.68 132.44 469.46",
    fill: "url(#adp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "op",
    x1: -8.4731,
    x2: -7.2459,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(63 0 0 -131 588.9688 142173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB4E3B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5514E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "132.44 308.68 55.183 469.46 132.44 469.46",
    fill: "url(#op)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sm",
    x1: -1.1606,
    x2: 0.0659,
    y1: 1082,
    y2: 1080.8,
    gradientTransform: "matrix(118 0 0 -172 1927 187030)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D047F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A0483",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1763.4 1011.9 1803.2 1080 1882.4 1080 1908.1 966.53",
    fill: "url(#sm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adx",
    x1: -2.0313,
    x2: -0.8044,
    y1: 1085.5,
    y2: 1084.3,
    gradientTransform: "matrix(120 0 0 -55 1687 59990)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A5DE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11BAE3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1494.8 338.13 1618.7 343.04 1471.5 275.54",
    fill: "url(#adx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph",
    x1: -1.6533,
    x2: -0.4262,
    y1: 1081.8,
    y2: 1080.5,
    gradientTransform: "matrix(99 0 0 -172 2025 187030)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800489",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#650276",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1882.4 1080 1924 1080 1924 1001.1 1908.1 966.53",
    fill: "url(#ph)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pt",
    x1: -2.0015,
    x2: -0.7745,
    y1: 1083.7,
    y2: 1082.4,
    gradientTransform: "matrix(143 0 0 -41 1409.9 45471)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0CCC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D70CCB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1160.1 1078.2 1287.4 1080 1333.4 1080 1182.1 1030.4",
    fill: "url(#pt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qe",
    x1: -2.0723,
    x2: -0.8454,
    y1: 1085.3,
    y2: 1084,
    gradientTransform: "matrix(101 0 0 -61 1725 66527)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12BEE3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10C9E5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1586.8 413 1618.7 343.04 1494.8 338.13",
    fill: "url(#qe)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qq",
    x1: -3.5088,
    x2: -2.2822,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(73 0 0 -144 1797 156311)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BB1D6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECBE2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1548.8 589.74 1638.3 475.6 1586.8 413",
    fill: "url(#qq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rb",
    x1: -4.4194,
    x2: -3.1927,
    y1: 1085.4,
    y2: 1084.2,
    gradientTransform: "matrix(91 0 0 -49 1125 53634)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#943790",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A04D86",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "858.4 486.64 749.26 435.09 746.81 495.23",
    fill: "url(#rb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rn",
    x1: -2.248,
    x2: -1.0213,
    y1: 1083.4,
    y2: 1082.1,
    gradientTransform: "matrix(146 0 0 -136 1079 147253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB9D4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11AACA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "904.41 0 776.33 0 876.79 76.709",
    fill: "url(#rn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ry",
    x1: -5.6982,
    x2: -4.4712,
    y1: 1085.9,
    y2: 1084.7,
    gradientTransform: "matrix(72 0 0 -62 1052 67385)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23B8CB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CC0D2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "680.59 140.53 722.28 77.937 633.99 64.435",
    fill: "url(#ry)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sj",
    x1: -3.2158,
    x2: -1.9889,
    y1: 1085.7,
    y2: 1084.5,
    gradientTransform: "matrix(96 0 0 -56 1350 61090)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8A27E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E49C7C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1146.6 298.86 1028.9 307.45 1079.1 367.59",
    fill: "url(#sj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sv",
    x1: -5.0645,
    x2: -3.8376,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(84 0 0 -91 997 99225)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D021E3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2BE4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "636.44 667.06 581.26 778.75 684.27 708.79",
    fill: "url(#sv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tg",
    x1: -4.4814,
    x2: -3.2548,
    y1: 1085.9,
    y2: 1084.6,
    gradientTransform: "matrix(91 0 0 -62 980 67385)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB2C4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35AEBF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "633.99 64.435 569 100.03 680.59 140.53",
    fill: "url(#tg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tt",
    x1: -2.0513,
    x2: -0.8242,
    y1: 1083.6,
    y2: 1082.3,
    gradientTransform: "matrix(136 0 0 -98 1351 106492)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5A480",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC948B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1245.9 419.14 1146.6 298.86 1079.1 367.59",
    fill: "url(#tt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ue",
    x1: -3.5986,
    x2: -2.3728,
    y1: 1083.1,
    y2: 1081.9,
    gradientTransform: "matrix(70 0 0 -75 1793 82064)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#510389",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#380587",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1540.2 921.12 1581.9 924.8 1626.1 832.75",
    fill: "url(#ue)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uq",
    x1: -1.7017,
    x2: -0.4748,
    y1: 1082.9,
    y2: 1081.6,
    gradientTransform: "matrix(127 0 0 -75 1770 82064)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F0383",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#290582",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1626.1 832.75 1581.9 924.8 1737.6 917.44",
    fill: "url(#uq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vb",
    x1: -9.5664,
    x2: -8.3397,
    y1: 1083.1,
    y2: 1081.9,
    gradientTransform: "matrix(56 0 0 -123 659 133402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A6D80",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#488297",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "133.66 157.71 132.44 308.68 201.11 237.49",
    fill: "url(#vb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vm",
    x1: -4.7979,
    x2: -3.571,
    y1: 1085.5,
    y2: 1084.2,
    gradientTransform: "matrix(98 0 0 -65 618 70704)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427992",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45879A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "133.66 157.71 201.11 237.49 253.84 165.08",
    fill: "url(#vm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vy",
    x1: -2.3613,
    x2: -1.1333,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(88 0 0 -135 2068 146550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061468",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081372",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 517.38 1924 486.82 1899.5 539.42",
    fill: "url(#vy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wj",
    x1: -6.2588,
    x2: -5.0316,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(78 0 0 -139 681 150935)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF3541",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62E46",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "186.4 448.59 221.96 619.19 282.05 465.78",
    fill: "url(#wj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wv",
    x1: -1.8633,
    x2: -0.6366,
    y1: 1083.8,
    y2: 1082.6,
    gradientTransform: "matrix(99 0 0 -102 1978 110626)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1398",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051C96",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1855.4 190.85 1924 157.71 1802.6 65.663",
    fill: "url(#wv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xg",
    x1: -2.5439,
    x2: -1.3168,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(79 0 0 -80 1945 87535)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E0277",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#530377",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1737.6 917.44 1763.4 1011.9 1834.5 913.75",
    fill: "url(#xg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xs",
    x1: -1.5439,
    x2: -0.3172,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(118 0 0 -80 1927 87535)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660378",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#510273",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1834.5 913.75 1763.4 1011.9 1908.1 966.53",
    fill: "url(#xs)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ye",
    x1: -1.8408,
    x2: -0.614,
    y1: 1084.3,
    y2: 1083.1,
    gradientTransform: "matrix(135 0 0 -39 1301 43309)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D30ACA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D90DCE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1160.1 1078.2 1182.1 1030.4 1016.6 1035.3",
    fill: "url(#ye)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yp",
    x1: -3.5371,
    x2: -2.3105,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(85 0 0 -97 1453 105509)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7E89",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF948F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1215.2 538.19 1245.9 419.14 1141.7 489.1",
    fill: "url(#yp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zb",
    x1: -2.0142,
    x2: -0.7876,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(136 0 0 -99 1351 107629)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5A881",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9B8C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1245.9 419.14 1079.1 367.59 1141.7 489.1",
    fill: "url(#zb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zm",
    x1: -3.4023,
    x2: -2.1754,
    y1: 1082.2,
    y2: 1081,
    gradientTransform: "matrix(74 0 0 -140 1715 152401)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A806A2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9405A0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1449.5 929.71 1498 1080 1505.1 1080 1540.2 921.12",
    fill: "url(#zm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zy",
    x1: -4.0469,
    x2: -2.8205,
    y1: 1082,
    y2: 1080.8,
    gradientTransform: "matrix(65 0 0 -140 1767 1.524e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#780391",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#850499",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1540.2 921.12 1505.1 1080 1508.3 1080 1581.9 924.8",
    fill: "url(#zy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaj",
    x1: -9.9424,
    x2: -8.7159,
    y1: 1087,
    y2: 1085.8,
    gradientTransform: "matrix(55 0 0 -38 542 41771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95530",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E45032",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "55.183 469.46 0 493.56 0 503.82 30.657 516.1",
    fill: "url(#aaj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aav",
    x1: -9.0986,
    x2: -7.8711,
    y1: 1084,
    y2: 1082.7,
    gradientTransform: "matrix(58 0 0 -77 642.97 83913)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D04B39",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD4C39",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "132.44 469.46 115.27 543.1 186.4 448.59",
    fill: "url(#aav)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abg",
    x1: -5.6982,
    x2: -4.4717,
    y1: 1082.7,
    y2: 1081.4,
    gradientTransform: "matrix(87 0 0 -139 614 150935)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2423D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA4E38",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "115.27 543.1 221.96 619.19 186.4 448.59",
    fill: "url(#abg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abr",
    x1: -7.8203,
    x2: -6.5934,
    y1: 1084.6,
    y2: 1083.4,
    gradientTransform: "matrix(69 0 0 -60 562.97 65553)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95931",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E55933",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "55.183 469.46 30.657 516.1 115.27 543.1",
    fill: "url(#abr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acd",
    x1: -7.627,
    x2: -6.3999,
    y1: 1082.7,
    y2: 1081.4,
    gradientTransform: "matrix(69 0 0 -136 562.9688 147747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6130",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6531",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "30.657 516.1 68.672 683.02 115.27 543.1",
    fill: "url(#acd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aci",
    x1: -8.2344,
    x2: -7.0074,
    y1: 1085,
    y2: 1083.7,
    gradientTransform: "matrix(63 0 0 -60 588.97 65553)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF5335",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5536",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "132.44 469.46 55.183 469.46 115.27 543.1",
    fill: "url(#aci)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acj",
    x1: -3.9224,
    x2: -2.6955,
    y1: 1082.7,
    y2: 1081.4,
    gradientTransform: "matrix(125 0 0 -114 538 123987)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6730",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E15736",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "115.27 543.1 68.672 683.02 221.96 619.19",
    fill: "url(#acj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ack",
    x1: -7.0249,
    x2: -5.7984,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(65 0 0 -114 892.9688 123636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#845D72",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#766881",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "510.14 252.22 505.23 112.3 430.43 201.9",
    fill: "url(#ack)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acl",
    x1: -8.8569,
    x2: -7.6298,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(52 0 0 -124 967 134436)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B838B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F7A95",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "569 100.03 505.23 112.3 510.14 252.22",
    fill: "url(#acl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acm",
    x1: -2.2847,
    x2: -1.0584,
    y1: 1085.3,
    y2: 1084.1,
    gradientTransform: "matrix(113 0 0 -60 1540 65399)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B6FA8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3882BB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1421.3 287.81 1282.7 280.45 1293.7 354.09",
    fill: "url(#acm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acn",
    x1: -4.5957,
    x2: -3.3689,
    y1: 1086.2,
    y2: 1085,
    gradientTransform: "matrix(60 0 0 -51 1706 55666)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1798D9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169CD8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1471.5 275.54 1421.3 287.81 1494.8 338.13",
    fill: "url(#acn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aco",
    x1: -8.4541,
    x2: -7.2277,
    y1: 1082.2,
    y2: 1081,
    gradientTransform: "matrix(38 0 0 -111 1658 121083)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D90ECA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40DC2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1335.7 1080 1365.7 1080 1382 959.17",
    fill: "url(#aco)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acp",
    x1: -2.3716,
    x2: -1.1448,
    y1: 1082,
    y2: 1080.7,
    gradientTransform: "matrix(113 0 0 -111 1606 121083)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF0BC4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60AB7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1365.7 1080 1490.6 1080 1382 959.17",
    fill: "url(#acp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acq",
    x1: -2.4756,
    x2: -1.2489,
    y1: 1082.2,
    y2: 1080.9,
    gradientTransform: "matrix(98 0 0 -133 1636 144841)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B708AA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C30AB3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1382 959.17 1490.6 1080 1498 1080 1449.5 929.71",
    fill: "url(#acq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acr",
    x1: -2.4307,
    x2: -1.2036,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(112 0 0 -114 1509 124167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA0BAF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A90A9D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1243.5 875.71 1380.8 903.94 1326.8 764.02",
    fill: "url(#acr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "act",
    x1: -5.4268,
    x2: -4.2002,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(56 0 0 -45 1677 49692)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB0CB1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA0AA7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1382 959.17 1449.5 929.71 1380.8 903.94",
    fill: "url(#act)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acu",
    x1: -2.522,
    x2: -1.2955,
    y1: 1082.9,
    y2: 1081.6,
    gradientTransform: "matrix(91 0 0 -120 1779 130418)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09A4D2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09A6D6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1660.4 622.88 1638.3 475.6 1548.8 589.74",
    fill: "url(#acu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acv",
    x1: -3.96,
    x2: -2.7333,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(62 0 0 -120 1881 1.3042e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09BBDD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0696D2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1714.3 540.64 1638.3 475.6 1660.4 622.88",
    fill: "url(#acv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acx",
    x1: -4.7637,
    x2: -3.5368,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(101 0 0 -125 687 135815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B02F47",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77195B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "282.05 465.78 221.96 619.19 345.81 557.83",
    fill: "url(#acx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acy",
    x1: -5.4961,
    x2: -4.2694,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(83 0 0 -99 754 107685)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64165E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#501073",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "282.05 465.78 345.81 557.83 383.83 436.32",
    fill: "url(#acy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acz",
    x1: -5.6289,
    x2: -4.4021,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(83 0 0 -99 806 107685)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D0D84",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440D89",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "383.83 436.32 345.81 557.83 447.59 469.46",
    fill: "url(#acz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ada",
    x1: -7.8716,
    x2: -6.6443,
    y1: 1085.7,
    y2: 1084.5,
    gradientTransform: "matrix(39 0 0 -57 1727 62105)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B82D0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C7DD2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1469.1 257.13 1464.2 217.85 1421.3 287.81",
    fill: "url(#ada)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adb",
    x1: -7.4248,
    x2: -6.1976,
    y1: 1091.5,
    y2: 1090.3,
    gradientTransform: "matrix(41 0 0 -25 1725 27545)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A88D1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#188DD6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1469.1 257.13 1421.3 287.81 1471.5 275.54",
    fill: "url(#adb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adc",
    x1: -1.8149,
    x2: -0.5882,
    y1: 1084.7,
    y2: 1083.5,
    gradientTransform: "matrix(122 0 0 -70 1683 76190)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169FDD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14A8DF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1618.7 343.04 1469.1 257.13 1471.5 275.54",
    fill: "url(#adc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "add",
    x1: -5.7773,
    x2: -4.5505,
    y1: 1082.2,
    y2: 1081,
    gradientTransform: "matrix(75 0 0 -164 1019 177974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6112C4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B819DA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "597.2 465.78 636.44 667.06 689.17 652.33",
    fill: "url(#add)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adf",
    x1: -10.16,
    x2: -8.9327,
    y1: 1085.4,
    y2: 1084.1,
    gradientTransform: "matrix(43 0 0 -46 1083 50568)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD1DE1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA22E1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "636.44 667.06 684.27 708.79 689.17 652.33",
    fill: "url(#adf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adg",
    x1: -8.3428,
    x2: -7.1153,
    y1: 1086.1,
    y2: 1084.8,
    gradientTransform: "matrix(55 0 0 -60 964 65202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#768D91",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599BA5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "572.68 38.661 505.23 112.3 569 100.03",
    fill: "url(#adg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adh",
    x1: -8.6011,
    x2: -7.3746,
    y1: 1086.9,
    y2: 1085.7,
    gradientTransform: "matrix(53 0 0 -50 1018 54392)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA1AF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A7B5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "633.99 64.435 572.68 38.661 569 100.03",
    fill: "url(#adh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adi",
    x1: -38.966,
    x2: -37.739,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(15 0 0 -78 619 85399)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B0A4C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#870753",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "33.11 945.67 44.146 1041.4 51.504 973.89",
    fill: "url(#adi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adj",
    x1: -3.8687,
    x2: -2.642,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(79 0 0 -99 1540 107295)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25177A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351A87",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1337.9 79.164 1274.8 0 1258.4 0 1269.2 26.388",
    fill: "url(#adj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adk",
    x1: -5.3652,
    x2: -4.1382,
    y1: 1082.1,
    y2: 1080.9,
    gradientTransform: "matrix(49 0 0 -156 1884 169469)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121196",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2EA7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1666.5 641.28 1626.1 832.75 1686.1 822.93",
    fill: "url(#adk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adl",
    x1: -2.2412,
    x2: -1.0144,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(91 0 0 -77 1842 84218)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0889",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#210685",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1626.1 832.75 1737.6 917.44 1686.1 822.93",
    fill: "url(#adl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adm",
    x1: -12.022,
    x2: -10.795,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(29 0 0 -86 1604 93505)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6275A0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#688AA7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1293.7 354.09 1282.7 280.45 1258.2 386",
    fill: "url(#adm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adn",
    x1: -3.2954,
    x2: -2.0685,
    y1: 1083.7,
    y2: 1082.4,
    gradientTransform: "matrix(91 0 0 -98 1451 106492)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C08E88",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90949E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.2 386 1146.6 298.86 1245.9 419.14",
    fill: "url(#adn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ado",
    x1: -2.312,
    x2: -1.0852,
    y1: 1084.3,
    y2: 1083,
    gradientTransform: "matrix(111 0 0 -86 1431 93505)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B88486",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7E9A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1282.7 280.45 1146.6 298.86 1258.2 386",
    fill: "url(#ado)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adq",
    x1: -2.0923,
    x2: -0.8656,
    y1: 1082.6,
    y2: 1081.3,
    gradientTransform: "matrix(125 0 0 -83 1446 90831)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF0ECD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF10CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1182.1 1030.4 1333.4 1080 1335 1080 1269.2 978.8",
    fill: "url(#adq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adr",
    x1: -2.397,
    x2: -1.1704,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(112 0 0 -84 1509 91828)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D90EBA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60FB9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1243.5 875.71 1269.2 978.8 1380.8 903.94",
    fill: "url(#adr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ads",
    x1: -2.873,
    x2: -1.6463,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(92 0 0 -99 1550 108111)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD10CA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE10C2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1269.2 978.8 1335 1080 1335.7 1080 1382 959.17",
    fill: "url(#ads)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adt",
    x1: -3.0566,
    x2: -1.8292,
    y1: 1083.3,
    y2: 1082.1,
    gradientTransform: "matrix(92 0 0 -61 1550 66988)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0DB1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB10BD",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1269.2 978.8 1382 959.17 1380.8 903.94",
    fill: "url(#adt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adu",
    x1: -4.1279,
    x2: -2.9009,
    y1: 1083.2,
    y2: 1081.9,
    gradientTransform: "matrix(111 0 0 -126 604 136756)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684E64",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743C56",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "268.56 293.95 132.44 308.68 186.4 448.59",
    fill: "url(#adu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adv",
    x1: -4.4014,
    x2: -3.1743,
    y1: 1085.4,
    y2: 1084.2,
    gradientTransform: "matrix(111 0 0 -58 604 63202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595B73",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475578",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "201.11 237.49 132.44 308.68 268.56 293.95",
    fill: "url(#adv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "adw",
    x1: -6.3555,
    x2: -5.1284,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(78 0 0 -140 681 151890)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D3149",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#632A59",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "268.56 293.95 186.4 448.59 282.05 465.78",
    fill: "url(#adw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "om",
    x1: -9.2949,
    x2: -8.0683,
    y1: 1083.7,
    y2: 1082.5,
    gradientTransform: "matrix(55 0 0 -105 716 113950)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#436684",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455A7A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "201.11 237.49 268.56 293.95 253.84 165.08",
    fill: "url(#om)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "on",
    x1: -4.9209,
    x2: -3.6939,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(94 0 0 -113 720 122590)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A657D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D506A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "253.84 165.08 268.56 293.95 369.11 155.26",
    fill: "url(#on)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oo",
    x1: -5.1484,
    x2: -3.9217,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(94 0 0 -140 732 151890)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#621A58",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48216C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "383.83 436.32 268.56 293.95 282.05 465.78",
    fill: "url(#oo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oq",
    x1: -9.0137,
    x2: -7.7869,
    y1: 1083.9,
    y2: 1082.6,
    gradientTransform: "matrix(49 0 0 -62 1116 67864)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E629E4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E32AE1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "689.17 652.33 684.27 708.79 744.36 728.43",
    fill: "url(#oq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "or",
    x1: -7.9063,
    x2: -6.6794,
    y1: 1085.5,
    y2: 1084.3,
    gradientTransform: "matrix(53 0 0 -41 1112 45209)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB30E5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F33CE5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "684.27 708.79 749.26 759.11 744.36 728.43",
    fill: "url(#or)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "os",
    x1: -9.2739,
    x2: -8.0472,
    y1: 1089.9,
    y2: 1088.7,
    gradientTransform: "matrix(50 0 0 -34 1024 37062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA0AD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CA4B4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "633.99 32.524 589.17 0 584.04 0 572.68 38.661",
    fill: "url(#os)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ot",
    x1: -8.7788,
    x2: -7.5521,
    y1: 1093,
    y2: 1091.7,
    gradientTransform: "matrix(50 0 0 -26 1024 28443)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44A3B2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DAEC1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "633.99 32.524 572.68 38.661 633.99 64.435",
    fill: "url(#ot)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ou",
    x1: -6.021,
    x2: -4.7942,
    y1: 1089,
    y2: 1087.8,
    gradientTransform: "matrix(72 0 0 -37 1052 40334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B6C9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BACC",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "722.28 77.937 633.99 32.524 633.99 64.435",
    fill: "url(#ou)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ov",
    x1: -3.7617,
    x2: -2.5349,
    y1: 1085.3,
    y2: 1084,
    gradientTransform: "matrix(101 0 0 -75 1023 81374)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16C2D4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B8CE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "722.28 77.937 752.39 0 720.36 0 633.99 32.524",
    fill: "url(#ov)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ow",
    x1: -2.1396,
    x2: -0.9129,
    y1: 1084.5,
    y2: 1083.3,
    gradientTransform: "matrix(91 0 0 -69 1852 75271)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ABFDF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A5D7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1714.3 540.64 1749.9 455.96 1638.3 475.6",
    fill: "url(#ow)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pj",
    x1: -0.4878,
    x2: 0.7388,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(185 0 0 -135 1849 146550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#072B99",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05509E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1899.5 539.42 1924 486.82 1924 392.84 1749.9 455.96",
    fill: "url(#pj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qk",
    x1: -0.3838,
    x2: 0.8432,
    y1: 1084.2,
    y2: 1082.9,
    gradientTransform: "matrix(283 0 0 -99 1336 107295)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44138E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6614A8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1558.9 0 1274.8 0 1337.9 79.164",
    fill: "url(#qk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rl",
    x1: -3.5977,
    x2: -2.3707,
    y1: 1085,
    y2: 1083.8,
    gradientTransform: "matrix(96 0 0 -63 1350 68601)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19C7D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18E7D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1146.6 298.86 1049.7 230.13 1028.9 307.45",
    fill: "url(#rl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tn",
    x1: -1.4507,
    x2: -0.2228,
    y1: 1084.3,
    y2: 1083,
    gradientTransform: "matrix(137 0 0 -87 1664 94480)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2077D5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D76D6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1632.2 150.35 1464.2 217.85 1469.1 257.13",
    fill: "url(#tn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uo",
    x1: -1.3901,
    x2: -0.1634,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(133 0 0 -157 1672 170150)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1696DC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1697DF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1618.7 343.04 1632.2 150.35 1469.1 257.13",
    fill: "url(#uo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vp",
    x1: -1.2847,
    x2: -0.0582,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(139 0 0 -95 1799 103033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2919B2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B2EB6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1802.6 65.663 1699.6 33.751 1632.2 150.35",
    fill: "url(#vp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wq",
    x1: -2.3022,
    x2: -1.0755,
    y1: 1087.2,
    y2: 1086,
    gradientTransform: "matrix(137 0 0 -19 1297 21674)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0FD1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0ED0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1016.6 1035.3 1182.1 1030.4 1014.1 1011.9",
    fill: "url(#wq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xr",
    x1: -2.9873,
    x2: -1.7607,
    y1: 1083.7,
    y2: 1082.5,
    gradientTransform: "matrix(94 0 0 -68 1552 74373)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E1583",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A1086",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1326.8 764.02 1389.4 727.2 1274.1 680.56",
    fill: "url(#xr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ys",
    x1: -2.9243,
    x2: -1.698,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(94 0 0 -163 1552 176943)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#472487",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29439A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1274.1 680.56 1389.4 727.2 1374.7 527.14",
    fill: "url(#ys)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zt",
    x1: -3.7188,
    x2: -2.492,
    y1: 1082.1,
    y2: 1080.9,
    gradientTransform: "matrix(78 0 0 -163 1650 176943)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1662AD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202C94",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1389.4 727.2 1470.3 680.56 1374.7 527.14",
    fill: "url(#zt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aau",
    x1: -3.1094,
    x2: -1.8826,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(114 0 0 -106 1100 115409)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F236E0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F33DD1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "744.36 728.43 749.26 759.11 884.15 629.01",
    fill: "url(#aau)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abv",
    x1: -3.2578,
    x2: -2.0313,
    y1: 1084.2,
    y2: 1083,
    gradientTransform: "matrix(80 0 0 -61 1726 66745)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D4CAA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0875BE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1470.3 680.56 1568.4 620.42 1494.8 605.69",
    fill: "url(#abv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acw",
    x1: -1.5371,
    x2: -0.3105,
    y1: 1082.2,
    y2: 1081,
    gradientTransform: "matrix(127 0 0 -173 1679 187829)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E339F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3EA6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1470.3 680.56 1626.1 832.75 1568.4 620.42",
    fill: "url(#acw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ox",
    x1: -4.4546,
    x2: -3.2278,
    y1: 1089.1,
    y2: 1087.9,
    gradientTransform: "matrix(60 0 0 -25 1766 27816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0982C3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088BC8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1494.8 605.69 1568.4 620.42 1548.8 589.74",
    fill: "url(#ox)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oy",
    x1: -2.7603,
    x2: -1.5334,
    y1: 1088.2,
    y2: 1087,
    gradientTransform: "matrix(91 0 0 -27 1779 29978)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0893CC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0782C9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1548.8 589.74 1568.4 620.42 1660.4 622.88",
    fill: "url(#oy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oz",
    x1: -2.8203,
    x2: -1.5934,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(80 0 0 -173 1806 187829)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10249F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0762BF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1568.4 620.42 1626.1 832.75 1666.5 641.28",
    fill: "url(#oz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pa",
    x1: -2.7192,
    x2: -1.4923,
    y1: 1092.8,
    y2: 1091.5,
    gradientTransform: "matrix(80 0 0 -17 1806 19193)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#067AC9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0676C6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1568.4 620.42 1666.5 641.28 1660.4 622.88",
    fill: "url(#pa)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pb",
    x1: -1.5732,
    x2: -0.3462,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(137 0 0 -109 1664 118208)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2867D2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3550D1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1632.2 150.35 1569.6 84.073 1464.2 217.85",
    fill: "url(#pb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pc",
    x1: -2.1387,
    x2: -0.912,
    y1: 1084.9,
    y2: 1083.7,
    gradientTransform: "matrix(106 0 0 -77 1781 83539)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B14BB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4820BC",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1699.6 33.751 1614.4 0 1586 0 1569.6 84.073",
    fill: "url(#pc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pd",
    x1: -1.8467,
    x2: -0.62,
    y1: 1084.4,
    y2: 1083.1,
    gradientTransform: "matrix(106 0 0 -95 1781 103033)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D47CD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E28BF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1699.6 33.751 1569.6 84.073 1632.2 150.35",
    fill: "url(#pd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pe",
    x1: -5.4424,
    x2: -4.2157,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(97 0 0 -72 469 78643)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3502C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5A2D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 643.34 0 696.93 68.672 683.02",
    fill: "url(#pe)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pf",
    x1: -8.0313,
    x2: -6.8045,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(66 0 0 -94 499.9688 102331)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB502F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC532E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 503.82 0 553.29 30.657 516.1",
    fill: "url(#pf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pg",
    x1: -5.2495,
    x2: -4.0226,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(97 0 0 -136 469 147747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5D2F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5D2D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "30.657 516.1 0 553.29 0 643.34 68.672 683.02",
    fill: "url(#pg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pi",
    x1: -11.222,
    x2: -9.9945,
    y1: 1085.3,
    y2: 1084.1,
    gradientTransform: "matrix(41 0 0 -32 1034 35665)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85FE5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC63E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "573.9 975.12 624.18 935.85 586.16 937.07",
    fill: "url(#pi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pk",
    x1: -13.549,
    x2: -12.322,
    y1: 1082,
    y2: 1080.8,
    gradientTransform: "matrix(35 0 0 -129 1046 140394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E243E4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5FE6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "586.16 937.07 624.18 935.85 581.26 778.75",
    fill: "url(#pk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pl",
    x1: -1.7603,
    x2: -0.5333,
    y1: 1081.9,
    y2: 1080.7,
    gradientTransform: "matrix(124 0 0 -142 1708 154566)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A705A5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#880396",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1508.3 1080 1646.3 1080 1581.9 924.8",
    fill: "url(#pl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pm",
    x1: -1.1401,
    x2: 0.0866,
    y1: 1082,
    y2: 1080.7,
    gradientTransform: "matrix(148 0 0 -142 1749 154566)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660286",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89048D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1581.9 924.8 1646.3 1080 1678.2 1080 1763.4 1011.9",
    fill: "url(#pm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pn",
    x1: -1.9556,
    x2: -0.7294,
    y1: 1082.2,
    y2: 1080.9,
    gradientTransform: "matrix(95 0 0 -132 1861 143827)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F058E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE07A7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1678.2 1080 1766.5 1080 1763.4 1011.9",
    fill: "url(#pn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "po",
    x1: -2.4766,
    x2: -1.2502,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(128 0 0 -83 1015 90881)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E146E3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E541E3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "724.89 1080 777.34 1080 814.25 1040.2",
    fill: "url(#po)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp",
    x1: -1.4404,
    x2: -0.2136,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(188 0 0 -83 1006 90881)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E034E1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12EDD",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "777.34 1080 880.18 1080 814.25 1040.2",
    fill: "url(#pp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pq",
    x1: -6.4409,
    x2: -5.2142,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(47 0 0 -114 1642 124167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#850A8E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F0B95",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1380.8 903.94 1384.5 773.84 1326.8 764.02",
    fill: "url(#pq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pr",
    x1: -6.0371,
    x2: -4.8107,
    y1: 1085.7,
    y2: 1084.5,
    gradientTransform: "matrix(51 0 0 -38 1638 41981)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0C87",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#500F84",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1326.8 764.02 1384.5 773.84 1389.4 727.2",
    fill: "url(#pr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ps",
    x1: -5.5288,
    x2: -4.302,
    y1: 1082.1,
    y2: 1080.9,
    gradientTransform: "matrix(56 0 0 -127 1677 138228)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B10AA1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D0995",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1380.8 903.94 1449.5 929.71 1384.5 773.84",
    fill: "url(#ps)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pu",
    x1: -4.022,
    x2: -2.7943,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(70 0 0 -76 1666 83021)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341584",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341D8C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1389.4 727.2 1384.5 773.84 1470.3 680.56",
    fill: "url(#pu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pv",
    x1: -1.9302,
    x2: -0.7033,
    y1: 1082.2,
    y2: 1080.9,
    gradientTransform: "matrix(127 0 0 -127 1609 138228)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93079A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A078C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1449.5 929.71 1540.2 921.12 1384.5 773.84",
    fill: "url(#pv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pw",
    x1: -0.8633,
    x2: 0.3638,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(197 0 0 -124 1539 134909)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182492",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#320D88",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1384.5 773.84 1626.1 832.75 1470.3 680.56",
    fill: "url(#pw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "px",
    x1: -0.7095,
    x2: 0.5175,
    y1: 1082.5,
    y2: 1081.2,
    gradientTransform: "matrix(197 0 0 -120 1539 130661)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51058A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C0988",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1384.5 773.84 1540.2 921.12 1626.1 832.75",
    fill: "url(#px)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "py",
    x1: -3.5527,
    x2: -2.3264,
    y1: 1082.5,
    y2: 1081.2,
    gradientTransform: "matrix(125 0 0 -89 556 97382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#520261",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F0263",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "131.4 1080 179.95 1080 164.32 1058.6",
    fill: "url(#py)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pz",
    x1: -4.9966,
    x2: -3.7697,
    y1: 1083.3,
    y2: 1082.1,
    gradientTransform: "matrix(98 0 0 -53 545 58452)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75045D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580260",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "44.146 1041.4 71.799 1080 131.4 1080 164.32 1058.6",
    fill: "url(#pz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qa",
    x1: -5.3359,
    x2: -4.1092,
    y1: 1082.7,
    y2: 1081.4,
    gradientTransform: "matrix(98 0 0 -69 545 75693)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A055A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630657",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "44.146 1041.4 164.32 1058.6 51.504 973.89",
    fill: "url(#qa)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qb",
    x1: -2.9092,
    x2: -1.6822,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(70 0 0 -120 2033 1.3067e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#380374",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#370479",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1920.4 937.07 1886 789.79 1834.5 913.75",
    fill: "url(#qb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qc",
    x1: -2.7085,
    x2: -1.4816,
    y1: 1084.4,
    y2: 1083.2,
    gradientTransform: "matrix(70 0 0 -43 2033 47538)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#460273",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#570273",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1908.1 966.53 1920.4 937.07 1834.5 913.75",
    fill: "url(#qc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qd",
    x1: -2.4814,
    x2: -1.2545,
    y1: 1082.3,
    y2: 1081,
    gradientTransform: "matrix(76 0 0 -123 2069 133914)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27057B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E0373",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1920.4 937.07 1924 927.64 1924 788.29 1886 789.79",
    fill: "url(#qd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qf",
    x1: -3.2441,
    x2: -2.0174,
    y1: 1081.9,
    y2: 1080.7,
    gradientTransform: "matrix(60 0 0 -154 2103 1.6755e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#670277",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E0375",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1908.1 966.53 1924 1001.1 1924 948.41 1920.4 937.07",
    fill: "url(#qf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qg",
    x1: -4.2988,
    x2: -3.0741,
    y1: 1081.4,
    y2: 1080.1,
    gradientTransform: "matrix(50 0 0 -277 2123 3.0039e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B0374",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A0374",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 948.41 1924 927.64 1920.4 937.07",
    fill: "url(#qg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qh",
    x1: -11.206,
    x2: -9.9798,
    y1: 1081.5,
    y2: 1080.3,
    gradientTransform: "matrix(50 0 0 -370 534 4.0085e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA2B3A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A20B5E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 814.44 0 1064.4 33.11 945.67",
    fill: "url(#qh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qi",
    x1: -9.5576,
    x2: -8.3306,
    y1: 1082,
    y2: 1080.7,
    gradientTransform: "matrix(57 0 0 -172 528.9688 187013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#940954",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1066D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "33.11 945.67 0 1064.4 0 1080 20.758 1080 44.146 1041.4",
    fill: "url(#qi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qj",
    x1: -5.2368,
    x2: -4.0097,
    y1: 1082.5,
    y2: 1081.2,
    gradientTransform: "matrix(95 0 0 -94 491 102773)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900563",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#970571",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "20.758 1080 71.799 1080 44.146 1041.4",
    fill: "url(#qj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ql",
    x1: -3.1343,
    x2: -1.9074,
    y1: 1082.1,
    y2: 1080.9,
    gradientTransform: "matrix(111 0 0 -116 1160 1.2651e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC3CE2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E430DC",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "814.25 1040.2 880.18 1080 924.44 1080 863.3 980.03",
    fill: "url(#ql)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qm",
    x1: -2.4873,
    x2: -1.2606,
    y1: 1082.2,
    y2: 1081,
    gradientTransform: "matrix(125 0 0 -116 1186 1.2651e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D919D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E529DB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "863.3 980.03 924.44 1080 982.59 1080 1016.6 1035.3",
    fill: "url(#qm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qn",
    x1: -2.458,
    x2: -1.2312,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(125 0 0 -45 1186 49754)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31AD9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E629DB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "863.3 980.03 1016.6 1035.3 1014.1 1011.9",
    fill: "url(#qn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qo",
    x1: -2.3721,
    x2: -1.1455,
    y1: 1083.3,
    y2: 1082.1,
    gradientTransform: "matrix(128 0 0 -63 1183 69175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E51CDA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB2DDE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1020.3 934.62 863.3 980.03 1014.1 1011.9",
    fill: "url(#qo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qp",
    x1: -6.6104,
    x2: -5.3837,
    y1: 1083.5,
    y2: 1082.2,
    gradientTransform: "matrix(77 0 0 -123 562 133402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#637081",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#618896",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "39.241 220.31 132.44 308.68 133.66 157.71",
    fill: "url(#qp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qr",
    x1: -4.7334,
    x2: -3.5067,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(108 0 0 -149 500 161410)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737A89",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#658C99",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1.226 37.434 39.241 220.31 133.66 157.71",
    fill: "url(#qr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qs",
    x1: -1.2539,
    x2: -0.027,
    y1: 1084.9,
    y2: 1083.6,
    gradientTransform: "matrix(148 0 0 -81 1754 87818)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600CAF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30099B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1723.4 0 1614.4 0 1699.6 33.751",
    fill: "url(#qs)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qt",
    x1: -2.6221,
    x2: -1.3953,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(84 0 0 -107 1909 115924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270DA1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19088F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1802.6 65.663 1786.1 0 1723.4 0 1699.6 33.751",
    fill: "url(#qt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qu",
    x1: -2.9551,
    x2: -1.7286,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(73 0 0 -107 1977 115924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100B90",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120583",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1859 31.297 1830.2 0 1786.1 0 1802.6 65.663",
    fill: "url(#qu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qv",
    x1: -0.978,
    x2: 0.2491,
    y1: 1084.5,
    y2: 1083.3,
    gradientTransform: "matrix(157 0 0 -87 1893 94296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#140279",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0476",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1889.2 0 1830.2 0 1859 31.297",
    fill: "url(#qv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qw",
    x1: -2.4761,
    x2: -1.2493,
    y1: 1084.4,
    y2: 1083.2,
    gradientTransform: "matrix(84 0 0 -87 2039 94296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09067B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0573",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1909.3 26.388 1923 0 1889.2 0 1859 31.297",
    fill: "url(#qw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qx",
    x1: -4.3618,
    x2: -3.1344,
    y1: 1084.4,
    y2: 1083.2,
    gradientTransform: "matrix(52 0 0 -83 2112 89972)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080675",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0570",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 24.406 1924 0 1923 0 1909.3 26.388",
    fill: "url(#qx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qy",
    x1: -1.731,
    x2: -0.5039,
    y1: 1089.8,
    y2: 1088.6,
    gradientTransform: "matrix(105 0 0 -34 1972 37090)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C8F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070983",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1802.6 65.663 1924 72.606 1924 68.784 1859 31.297",
    fill: "url(#qy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qz",
    x1: -1.3647,
    x2: -0.1379,
    y1: 1085.2,
    y2: 1084,
    gradientTransform: "matrix(105 0 0 -75 1972 81439)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0F91",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#040F86",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 157.71 1924 72.606 1802.6 65.663",
    fill: "url(#qz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ra",
    x1: -3.2939,
    x2: -2.0673,
    y1: 1089.2,
    y2: 1088,
    gradientTransform: "matrix(59 0 0 -38 2064 41410)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080881",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06087D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1859 31.297 1924 68.784 1924 57.481 1909.3 26.388",
    fill: "url(#ra)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rc",
    x1: -4.0127,
    x2: -2.7856,
    y1: 1087.7,
    y2: 1086.5,
    gradientTransform: "matrix(52 0 0 -45 2112 48970)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060879",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050978",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 57.481 1924 24.406 1909.3 26.388",
    fill: "url(#rc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rd",
    x1: -0.6377,
    x2: 0.5895,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(185 0 0 -145 1849 157282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0570BA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032A88",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1749.9 455.96 1924 392.84 1924 306.24 1902 277.99",
    fill: "url(#rd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "re",
    x1: -3.5186,
    x2: -2.2919,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(56 0 0 -98 2064 106377)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04249C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#032091",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1902 277.99 1924 157.71 1855.4 190.85",
    fill: "url(#re)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rf",
    x1: -5.6309,
    x2: -4.4022,
    y1: 1083.1,
    y2: 1081.9,
    gradientTransform: "matrix(40 0 0 -122 2118 132297)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03178A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031C8B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 210.61 1924 157.71 1902 277.99",
    fill: "url(#rf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rg",
    x1: -3.397,
    x2: -2.1706,
    y1: 1082.2,
    y2: 1081,
    gradientTransform: "matrix(61 0 0 -200 2097 2.1662e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031883",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03207F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 306.24 1924 210.61 1902 277.99",
    fill: "url(#rg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rh",
    x1: -2.2842,
    x2: -1.0575,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(99 0 0 -157 1828 170150)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EB2E3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127ED7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1740.1 257.13 1632.2 150.35 1618.7 343.04",
    fill: "url(#rh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ri",
    x1: -1.0298,
    x2: 0.1969,
    y1: 1083.1,
    y2: 1081.9,
    gradientTransform: "matrix(139 0 0 -156 1799 169000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1951CC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D47BA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1740.1 257.13 1802.6 65.663 1632.2 150.35",
    fill: "url(#ri)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rj",
    x1: -1.1802,
    x2: 0.0462,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(132 0 0 -162 1894 175642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058CCE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0560BA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1749.9 455.96 1902 277.99 1740.1 257.13",
    fill: "url(#rj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rk",
    x1: -2.1826,
    x2: -0.9556,
    y1: 1082.8,
    y2: 1081.5,
    gradientTransform: "matrix(94 0 0 -156 1932 169000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C20A5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0748B7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1855.4 190.85 1802.6 65.663 1740.1 257.13",
    fill: "url(#rk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rm",
    x1: -1.1816,
    x2: 0.0456,
    y1: 1084.9,
    y2: 1083.6,
    gradientTransform: "matrix(132 0 0 -71 1894 77217)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0533A9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054EB2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1902 277.99 1855.4 190.85 1740.1 257.13",
    fill: "url(#rm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ro",
    x1: -4.1587,
    x2: -2.9319,
    y1: 1085.2,
    y2: 1083.9,
    gradientTransform: "matrix(63 0 0 -57 1838 62207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10CDE5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EC8E5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1586.8 413 1664.1 382.32 1618.7 343.04",
    fill: "url(#ro)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rp",
    x1: -3.7822,
    x2: -2.5555,
    y1: 1084.4,
    y2: 1083.1,
    gradientTransform: "matrix(63 0 0 -76 1838 82778)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10CFE4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DCAE3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1638.3 475.6 1664.1 382.32 1586.8 413",
    fill: "url(#rp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rq",
    x1: -2.0181,
    x2: -0.7913,
    y1: 1083.7,
    y2: 1082.4,
    gradientTransform: "matrix(99 0 0 -102 1828 110782)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC0E5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AABDE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1664.1 382.32 1740.1 257.13 1618.7 343.04",
    fill: "url(#rq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rr",
    x1: -2.585,
    x2: -1.3583,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(91 0 0 -76 1852 82778)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BC6E2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09B9DE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1638.3 475.6 1749.9 455.96 1664.1 382.32",
    fill: "url(#rr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rs",
    x1: -3.2056,
    x2: -1.9791,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(70 0 0 -162 1894 1.7564e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#089AD9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08B4DD",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1664.1 382.32 1749.9 455.96 1740.1 257.13",
    fill: "url(#rs)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rt",
    x1: -3.2813,
    x2: -2.0545,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(95 0 0 -104 1452 112700)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1C74",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26297A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1269.2 26.388 1258.4 0 1211.7 0 1152.7 85.3",
    fill: "url(#rt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ru",
    x1: -4.2764,
    x2: -3.0494,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(82 0 0 -122 1282 132389)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9AA7D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFA789",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1028.9 307.45 928.3 241.17 984.71 390.91",
    fill: "url(#ru)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rv",
    x1: -3.1475,
    x2: -1.9207,
    y1: 1085.5,
    y2: 1084.3,
    gradientTransform: "matrix(99 0 0 -63 1265 68601)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA182",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9C8B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1049.7 230.13 928.3 241.17 1028.9 307.45",
    fill: "url(#rv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rw",
    x1: -3.6953,
    x2: -2.4683,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(104 0 0 -94 1058 101988)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC1D1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25C3CF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "808.12 193.31 722.28 77.937 680.59 140.53",
    fill: "url(#rw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rx",
    x1: -8.1504,
    x2: -6.924,
    y1: 1082.9,
    y2: 1081.6,
    gradientTransform: "matrix(55 0 0 -127 1039 137850)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#281EAF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253BA7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "664.65 368.82 603.33 309.9 597.2 465.78",
    fill: "url(#rx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rz",
    x1: -5.4722,
    x2: -4.2452,
    y1: 1083.8,
    y2: 1082.6,
    gradientTransform: "matrix(72 0 0 -73 1097 79744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC21DC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E92CD9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "689.17 652.33 744.36 728.43 777.46 638.83",
    fill: "url(#rz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sa",
    x1: -5.7705,
    x2: -4.5434,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(72 0 0 -128 1097 1.3908e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB1DCE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB26B6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "746.81 495.23 689.17 652.33 777.46 638.83",
    fill: "url(#sa)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sb",
    x1: -3.1221,
    x2: -1.8945,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(114 0 0 -81 1100 88384)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF33DA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB32C4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "744.36 728.43 884.15 629.01 777.46 638.83",
    fill: "url(#sb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sc",
    x1: -4.0723,
    x2: -2.8451,
    y1: 1082.9,
    y2: 1081.6,
    gradientTransform: "matrix(91 0 0 -124 1125 134751)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72F99",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D640A0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "777.46 638.83 858.4 486.64 746.81 495.23",
    fill: "url(#sc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sd",
    x1: -4.4038,
    x2: -3.1766,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(87 0 0 -124 1154 134751)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF4F8F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E835B5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "777.46 638.83 884.15 629.01 858.4 486.64",
    fill: "url(#sd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "se",
    x1: -2.1758,
    x2: -0.9487,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(148 0 0 -138 1070 1.5e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F542E0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F23FCE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "749.26 759.11 930.75 798.39 884.15 629.01",
    fill: "url(#se)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sf",
    x1: -3.3887,
    x2: -2.1616,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(99 0 0 -138 1229 1.5e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03CBA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3FBF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "884.15 629.01 930.75 798.39 1005.6 641.28",
    fill: "url(#sf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sg",
    x1: -3.4731,
    x2: -2.2463,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(100 0 0 -128 1266 139201)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED37D0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E432B3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "930.75 798.39 1053.4 735.79 1005.6 641.28",
    fill: "url(#sg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sh",
    x1: -3.1431,
    x2: -1.9163,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(100 0 0 -162 1266 176032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE32DA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E320CD",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "930.75 798.39 1020.3 934.62 1053.4 735.79",
    fill: "url(#sh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "si",
    x1: -3.6206,
    x2: -2.3938,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(89 0 0 -77 1338 84070)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33CA0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52DA0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1005.6 641.28 1053.4 735.79 1114.7 647.42",
    fill: "url(#si)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sk",
    x1: -2.2808,
    x2: -1.0537,
    y1: 1083,
    y2: 1081.8,
    gradientTransform: "matrix(114 0 0 -91 1461 99304)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C80AAF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A50A9C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1187 770.16 1243.5 875.71 1326.8 764.02",
    fill: "url(#sk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sl",
    x1: -2.5195,
    x2: -1.2927,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(114 0 0 -73 1461 79778)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781387",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960B94",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1187 770.16 1326.8 764.02 1274.1 680.56",
    fill: "url(#sl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sn",
    x1: -2.8662,
    x2: -1.6393,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(109 0 0 -100 1357 108938)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D01DAD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31E9A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1053.4 735.79 1187 770.16 1114.7 647.42",
    fill: "url(#sn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "so",
    x1: -2.0313,
    x2: -0.8041,
    y1: 1083,
    y2: 1081.7,
    gradientTransform: "matrix(130 0 0 -100 1386 108938)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B52689",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951390",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1114.7 647.42 1187 770.16 1274.1 680.56",
    fill: "url(#so)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sp",
    x1: -2.646,
    x2: -1.4195,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(111 0 0 -95 1420 103750)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E00DCC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E20ECA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1182.1 1030.4 1269.2 978.8 1133.1 913.75",
    fill: "url(#sp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sq",
    x1: -3.5796,
    x2: -2.3528,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(90 0 0 -117 1441 1.2742e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C70AB0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D80BC0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1133.1 913.75 1243.5 875.71 1187 770.16",
    fill: "url(#sq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sr",
    x1: -2.4502,
    x2: -1.2236,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(111 0 0 -84 1420 91828)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0CBF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E10EC8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1133.1 913.75 1269.2 978.8 1243.5 875.71",
    fill: "url(#sr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss",
    x1: -2.1074,
    x2: -0.8804,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(137 0 0 -95 1297 103750)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF10D2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0CCC",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1014.1 1011.9 1182.1 1030.4 1133.1 913.75",
    fill: "url(#ss)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "st",
    x1: -3.3286,
    x2: -2.1011,
    y1: 1082.8,
    y2: 1081.5,
    gradientTransform: "matrix(97 0 0 -80 1337 87535)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E112D5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E212D3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1014.1 1011.9 1133.1 913.75 1020.3 934.62",
    fill: "url(#st)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "su",
    x1: -3.77,
    x2: -2.5432,
    y1: 1081.9,
    y2: 1080.6,
    gradientTransform: "matrix(92 0 0 -162 1347 176032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E316D4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE15C6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1020.3 934.62 1133.1 913.75 1053.4 735.79",
    fill: "url(#su)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw",
    x1: -2.6626,
    x2: -1.4357,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(109 0 0 -145 1357 157655)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D517BA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0CB9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1053.4 735.79 1133.1 913.75 1187 770.16",
    fill: "url(#sw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sx",
    x1: -2.1924,
    x2: -0.9659,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(148 0 0 -88 1070 96057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74FE4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F757E1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "749.26 759.11 800.76 867.11 930.75 798.39",
    fill: "url(#sx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sy",
    x1: -4.4468,
    x2: -3.2198,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(82 0 0 -92 1178 100469)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F866E3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F552E2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "800.76 867.11 863.3 980.03 901.32 880.62",
    fill: "url(#sy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sz",
    x1: -3.2827,
    x2: -2.0561,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(106 0 0 -67 1154 73388)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F862E3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54BE0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "800.76 867.11 901.32 880.62 930.75 798.39",
    fill: "url(#sz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ta",
    x1: -2.665,
    x2: -1.4383,
    y1: 1082.7,
    y2: 1081.4,
    gradientTransform: "matrix(128 0 0 -81 1183 88589)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F242E1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE35DE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "901.32 880.62 863.3 980.03 1020.3 934.62",
    fill: "url(#ta)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tb",
    x1: -3.6528,
    x2: -2.426,
    y1: 1082.4,
    y2: 1081.1,
    gradientTransform: "matrix(97 0 0 -111 1245 120952)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F23BDF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE34DE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "901.32 880.62 1020.3 934.62 930.75 798.39",
    fill: "url(#tb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tc",
    x1: -3.3418,
    x2: -2.1151,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(114 0 0 -129 857 140394)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D432DE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C139CE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "586.16 937.07 581.26 778.75 446.37 797.16",
    fill: "url(#tc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "td",
    x1: -4.1362,
    x2: -2.9095,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(111 0 0 -113 749 123022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C136A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75148A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "310.25 824.16 446.37 797.16 365.43 685.47",
    fill: "url(#td)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "te",
    x1: -3.6636,
    x2: -2.4369,
    y1: 1083.7,
    y2: 1082.5,
    gradientTransform: "matrix(125 0 0 -74 538 80809)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86231",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D84C38",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "221.96 619.19 68.672 683.02 187.62 710.02",
    fill: "url(#te)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tf",
    x1: -4.478,
    x2: -3.2513,
    y1: 1081.9,
    y2: 1080.7,
    gradientTransform: "matrix(112 0 0 -198 472 214921)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB3B30",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC243A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "109.14 820.48 0 726.85 0 814.44 33.11 945.67",
    fill: "url(#tf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ti",
    x1: -4.2842,
    x2: -3.0574,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(112 0 0 -112 472 121939)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4E2E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D74F31",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "68.672 683.02 0 696.93 0 726.85 109.14 820.48",
    fill: "url(#ti)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tj",
    x1: -5.085,
    x2: -3.8577,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(97 0 0 -112 566 121939)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E55F30",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D04634",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "68.672 683.02 109.14 820.48 187.62 710.02",
    fill: "url(#tj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tk",
    x1: -4.5186,
    x2: -3.2919,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(104 0 0 -93 545 101613)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D0850",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B0756",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "51.504 973.89 164.32 1058.6 179.04 944.44",
    fill: "url(#tk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tl",
    x1: -6.8462,
    x2: -5.6193,
    y1: 1082.2,
    y2: 1081,
    gradientTransform: "matrix(76 0 0 -93 665 101613)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360462",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#370865",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "164.32 1058.6 257.52 1047.5 179.04 944.44",
    fill: "url(#tl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm",
    x1: -6.313,
    x2: -5.0868,
    y1: 1082.5,
    y2: 1081.2,
    gradientTransform: "matrix(76 0 0 -98 665 107102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E0368",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200471",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "164.32 1058.6 179.95 1080 253.88 1080 257.52 1047.5",
    fill: "url(#tm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "to",
    x1: -3.7793,
    x2: -2.5523,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(116 0 0 -87 637 95124)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#420B5D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#330B76",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "179.04 944.44 257.52 1047.5 321.29 940.76",
    fill: "url(#to)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tp",
    x1: -6.2759,
    x2: -5.0488,
    y1: 1082.5,
    y2: 1081.2,
    gradientTransform: "matrix(78 0 0 -87 739 95124)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B0E81",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310D8A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "257.52 1047.5 353.17 1020.5 321.29 940.76",
    fill: "url(#tp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tq",
    x1: -10.234,
    x2: -9.0076,
    y1: 1083.5,
    y2: 1082.2,
    gradientTransform: "matrix(55 0 0 -91 542 98997)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E24B32",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D54A38",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 390.72 0 493.56 55.183 469.46",
    fill: "url(#tq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tr",
    x1: -4.6768,
    x2: -3.45,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(110 0 0 -136 495 147506)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#826974",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93545B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "39.241 220.31 0 377.41 0 385.8 132.44 308.68",
    fill: "url(#tr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ts",
    x1: -4.3921,
    x2: -3.1652,
    y1: 1083.1,
    y2: 1081.8,
    gradientTransform: "matrix(110 0 0 -131 495 142173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4F3D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A24E50",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "132.44 308.68 0 385.8 0 390.72 55.183 469.46",
    fill: "url(#ts)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tu",
    x1: -7.7363,
    x2: -6.5091,
    y1: 1083.2,
    y2: 1081.9,
    gradientTransform: "matrix(69 0 0 -136 500.9688 147506)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B14B4D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#935C67",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 220.88 0 377.41 39.241 220.31",
    fill: "url(#tu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tv",
    x1: -7.8911,
    x2: -6.664,
    y1: 1083.1,
    y2: 1081.8,
    gradientTransform: "matrix(69 0 0 -150 500.9688 162491)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#846777",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E6470",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1.226 37.434 0 42.278 0 220.88 39.241 220.31",
    fill: "url(#tv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tw",
    x1: -14.825,
    x2: -13.599,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(38 0 0 -241 532 260771)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B515E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855665",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 33.583 0 42.278 1.226 37.434",
    fill: "url(#tw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tx",
    x1: -5.5654,
    x2: -4.3382,
    y1: 1084.3,
    y2: 1083.1,
    gradientTransform: "matrix(97 0 0 -91 482 98621)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#705263",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59627E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "34.691 0 0 0 0 33.583 1.226 37.434",
    fill: "url(#tx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ty",
    x1: -6.4224,
    x2: -5.1953,
    y1: 1085,
    y2: 1083.8,
    gradientTransform: "matrix(81 0 0 -77 595 83502)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D6F99",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D7CA1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "157.17 0 112.15 0 131.21 38.661",
    fill: "url(#ty)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tz",
    x1: -4.9468,
    x2: -3.7201,
    y1: 1084.9,
    y2: 1083.7,
    gradientTransform: "matrix(106 0 0 -77 502 83502)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#627087",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B7C9C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "131.21 38.661 112.15 0 34.691 0 1.226 37.434",
    fill: "url(#tz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ua",
    x1: -4.3213,
    x2: -3.0945,
    y1: 1084.4,
    y2: 1083.2,
    gradientTransform: "matrix(108 0 0 -98 500 106279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#677D8F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4797A9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "131.21 38.661 1.226 37.434 133.66 157.71",
    fill: "url(#ua)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ub",
    x1: -4.0596,
    x2: -2.8332,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(116 0 0 -97 598 105199)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A94A9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#468C9C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "273.46 54.617 131.21 38.661 133.66 157.71",
    fill: "url(#ub)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uc",
    x1: -4.2134,
    x2: -2.9866,
    y1: 1084.9,
    y2: 1083.7,
    gradientTransform: "matrix(116 0 0 -77 598 83515)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3588A4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#357392",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "273.46 54.617 221.73 0 157.17 0 131.21 38.661",
    fill: "url(#uc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ud",
    x1: -4.0879,
    x2: -2.8612,
    y1: 1084.4,
    y2: 1083.1,
    gradientTransform: "matrix(114 0 0 -90 602 97645)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4593A3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467A8C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "253.84 165.08 273.46 54.617 133.66 157.71",
    fill: "url(#ud)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uf",
    x1: -1.9629,
    x2: -0.7359,
    y1: 1083.6,
    y2: 1082.3,
    gradientTransform: "matrix(208 0 0 -118 549 1.278e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E6282",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74626A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "335.89 0 221.73 0 273.46 54.617",
    fill: "url(#uf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ug",
    x1: -6.6846,
    x2: -5.4581,
    y1: 1084.3,
    y2: 1083.1,
    gradientTransform: "matrix(73 0 0 -90 741 97645)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E7182",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626D77",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "343.36 58.298 273.46 54.617 253.84 165.08",
    fill: "url(#ug)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uh",
    x1: -5.0283,
    x2: -3.8011,
    y1: 1084.4,
    y2: 1083.2,
    gradientTransform: "matrix(94 0 0 -87 720 94405)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#566D7B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786369",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "369.11 155.26 343.36 58.298 253.84 165.08",
    fill: "url(#uh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ui",
    x1: -3.4097,
    x2: -2.1833,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(135 0 0 -121 695 131038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6971",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96615E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "343.36 58.298 380.91 0 335.89 0 273.46 54.617",
    fill: "url(#ui)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uj",
    x1: -5.8574,
    x2: -4.6315,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(83 0 0 -121 804 131038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976460",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B26157",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "404.56 0 380.91 0 343.36 58.298",
    fill: "url(#uj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uk",
    x1: -4.0596,
    x2: -2.8329,
    y1: 1083.6,
    y2: 1082.3,
    gradientTransform: "matrix(104 0 0 -123 866 133242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8583",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878481",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "572.68 38.661 508.91 0 460.53 0 505.23 112.3",
    fill: "url(#uk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ul",
    x1: -3.4795,
    x2: -2.2525,
    y1: 1086.2,
    y2: 1084.9,
    gradientTransform: "matrix(114 0 0 -63 856 68382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#699399",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F8484",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "584.04 0 508.91 0 572.68 38.661",
    fill: "url(#ul)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "um",
    x1: -11.616,
    x2: -10.39,
    y1: 1085.3,
    y2: 1084.1,
    gradientTransform: "matrix(40 0 0 -72 1044 78097)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449CAC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A0B2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "620.45 0 589.17 0 633.99 32.524",
    fill: "url(#um)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "un",
    x1: -5.1914,
    x2: -3.9647,
    y1: 1085.3,
    y2: 1084,
    gradientTransform: "matrix(83 0 0 -72 1011 78097)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359CB0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20ABC4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "658.25 0 620.45 0 633.99 32.524",
    fill: "url(#un)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "up",
    x1: -4.1377,
    x2: -2.9108,
    y1: 1085.2,
    y2: 1084,
    gradientTransform: "matrix(101 0 0 -71 1023 77017)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB2C9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B4D0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "720.36 0 658.25 0 633.99 32.524",
    fill: "url(#up)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ur",
    x1: -3.9204,
    x2: -2.6938,
    y1: 1083.1,
    y2: 1081.9,
    gradientTransform: "matrix(96 0 0 -136 1226 147253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0C9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#078CC0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "949.64 0 904.41 0 876.79 76.709",
    fill: "url(#ur)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "us",
    x1: -3.189,
    x2: -1.9625,
    y1: 1085.2,
    y2: 1084,
    gradientTransform: "matrix(98 0 0 -78 1320 84588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0969A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E498A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1112.8 0 1053.5 0 1111 46.025",
    fill: "url(#us)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ut",
    x1: -3.0977,
    x2: -1.8714,
    y1: 1084.8,
    y2: 1083.6,
    gradientTransform: "matrix(106 0 0 -78 1407 84588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A347C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15317B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1178.7 0 1112.8 0 1111 46.025",
    fill: "url(#ut)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uu",
    x1: -2.8687,
    x2: -1.6417,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(106 0 0 -104 1407 112700)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#203A7A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18327C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1152.7 85.3 1211.7 0 1178.7 0 1111 46.025",
    fill: "url(#uu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uv",
    x1: -3.4263,
    x2: -2.1985,
    y1: 1083.6,
    y2: 1082.3,
    gradientTransform: "matrix(99 0 0 -112 1265 121467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A19F96",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8B8E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1049.7 230.13 1039.9 103.71 928.3 241.17",
    fill: "url(#uv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uw",
    x1: -3.5283,
    x2: -2.3018,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(95 0 0 -123 1323 133235)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F76AC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#256A96",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1111 46.025 1053.5 0 1008.7 0 1039.9 103.71",
    fill: "url(#uw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ux",
    x1: -3.4863,
    x2: -2.2592,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(92 0 0 -118 1363 1.2794e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917D83",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#436489",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1152.7 85.3 1039.9 103.71 1049.7 230.13",
    fill: "url(#ux)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uy",
    x1: -3.627,
    x2: -2.4,
    y1: 1087.3,
    y2: 1086.1,
    gradientTransform: "matrix(92 0 0 -47 1363 51155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#215388",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#315E8A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1111 46.025 1039.9 103.71 1152.7 85.3",
    fill: "url(#uy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uz",
    x1: -1.7803,
    x2: -0.5535,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(140 0 0 -93 1323 100994)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD7F7B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A36A79",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1221.4 184.72 1049.7 230.13 1146.6 298.86",
    fill: "url(#uz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "va",
    x1: -2.0757,
    x2: -0.8486,
    y1: 1083.4,
    y2: 1082.1,
    gradientTransform: "matrix(140 0 0 -118 1323 1.2794e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99727B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534A78",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1221.4 184.72 1152.7 85.3 1049.7 230.13",
    fill: "url(#va)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vc",
    x1: -2.7017,
    x2: -1.4745,
    y1: 1083.8,
    y2: 1082.6,
    gradientTransform: "matrix(111 0 0 -93 1431 100994)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2767D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5A86",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1282.7 280.45 1221.4 184.72 1146.6 298.86",
    fill: "url(#vc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vd",
    x1: -2.9707,
    x2: -1.744,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(95 0 0 -129 1452 139781)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3978",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2F79",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1269.2 26.388 1152.7 85.3 1221.4 184.72",
    fill: "url(#vd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ve",
    x1: -3.7817,
    x2: -2.5553,
    y1: 1083.8,
    y2: 1082.6,
    gradientTransform: "matrix(96 0 0 -108 1226 117020)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EB5C7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A9DBD",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "935.66 85.3 973.53 0 949.64 0 876.79 76.709",
    fill: "url(#ve)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vf",
    x1: -3.8247,
    x2: -2.5983,
    y1: 1083.3,
    y2: 1082.1,
    gradientTransform: "matrix(91 0 0 -127 1273 137667)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6A1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449BAA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1039.9 103.71 935.66 85.3 928.3 241.17",
    fill: "url(#vf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vg",
    x1: -4.2612,
    x2: -3.0344,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(85 0 0 -123 1285 133235)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1389B6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F97AF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1039.9 103.71 1008.7 0 973.53 0 935.66 85.3",
    fill: "url(#vg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vh",
    x1: -4.0303,
    x2: -2.8034,
    y1: 1084.2,
    y2: 1083,
    gradientTransform: "matrix(93 0 0 -94 1103 101988)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC7D2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31C3C9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "836.33 140.53 722.28 77.937 808.12 193.31",
    fill: "url(#vh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vi",
    x1: -2.5342,
    x2: -1.3073,
    y1: 1086.9,
    y2: 1085.7,
    gradientTransform: "matrix(126 0 0 -52 1070 56585)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CC7D3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28C4CB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "876.79 76.709 722.28 77.937 836.33 140.53",
    fill: "url(#vi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vj",
    x1: -3.7617,
    x2: -2.5347,
    y1: 1084.4,
    y2: 1083.2,
    gradientTransform: "matrix(98 0 0 -82 1168 89067)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46BBBF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B7B4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "836.33 140.53 808.12 193.31 928.3 241.17",
    fill: "url(#vj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vk",
    x1: -4.6309,
    x2: -3.4044,
    y1: 1086.7,
    y2: 1085.4,
    gradientTransform: "matrix(81 0 0 -52 1208 56585)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29BEC7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BBC3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "935.66 85.3 876.79 76.709 836.33 140.53",
    fill: "url(#vk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vl",
    x1: -4.3916,
    x2: -3.1649,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(81 0 0 -127 1208 137667)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAFA9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB8BE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "928.3 241.17 935.66 85.3 836.33 140.53",
    fill: "url(#vl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vn",
    x1: -2.1724,
    x2: -0.9454,
    y1: 1084.2,
    y2: 1082.9,
    gradientTransform: "matrix(146 0 0 -82 1003 89225)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4C9E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706593",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "749.26 435.09 843.68 334.45 664.65 368.82",
    fill: "url(#vn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vo",
    x1: -4.2046,
    x2: -2.9779,
    y1: 1083.1,
    y2: 1081.8,
    gradientTransform: "matrix(89 0 0 -124 1129 134627)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865588",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37685",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "858.4 486.64 843.68 334.45 749.26 435.09",
    fill: "url(#vo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vq",
    x1: -3.686,
    x2: -2.4595,
    y1: 1083.4,
    y2: 1082.1,
    gradientTransform: "matrix(98 0 0 -115 1168 1.2478e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BB4B7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94A39D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "928.3 241.17 808.12 193.31 843.68 334.45",
    fill: "url(#vq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vr",
    x1: -3.0063,
    x2: -1.7798,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(115 0 0 -124 1180 134627)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA7D7A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9D81",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "984.71 390.91 843.68 334.45 858.4 486.64",
    fill: "url(#vr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vs",
    x1: -2.9321,
    x2: -1.7051,
    y1: 1083.2,
    y2: 1081.9,
    gradientTransform: "matrix(115 0 0 -122 1180 132389)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAA692",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A287",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "984.71 390.91 928.3 241.17 843.68 334.45",
    fill: "url(#vs)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vt",
    x1: -5.4487,
    x2: -4.222,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(75 0 0 -92 1024 99971)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2553AB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2364B1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "695.3 255.9 603.33 309.9 664.65 368.82",
    fill: "url(#vt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vu",
    x1: -2.5313,
    x2: -1.3044,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(146 0 0 -92 1003 99971)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D5AA9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#508AAA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "843.68 334.45 695.3 255.9 664.65 368.82",
    fill: "url(#vu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vv",
    x1: -3.7349,
    x2: -2.5081,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(104 0 0 -94 1058 102039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BACE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AADC5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "808.12 193.31 680.59 140.53 695.3 255.9",
    fill: "url(#vv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vw",
    x1: -2.8594,
    x2: -1.6328,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(121 0 0 -115 1053 1.2478e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB1BF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549AAE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "843.68 334.45 808.12 193.31 695.3 255.9",
    fill: "url(#vw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vx",
    x1: -4.0972,
    x2: -2.8702,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(104 0 0 -124 919 134436)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516996",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#408EAE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "569 100.03 510.14 252.22 637.67 237.49",
    fill: "url(#vx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vz",
    x1: -3.708,
    x2: -2.4813,
    y1: 1085.7,
    y2: 1084.5,
    gradientTransform: "matrix(104 0 0 -59 919 64283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#475795",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B66AC",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "637.67 237.49 510.14 252.22 603.33 309.9",
    fill: "url(#vz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wa",
    x1: -4.4185,
    x2: -3.1916,
    y1: 1083.7,
    y2: 1082.5,
    gradientTransform: "matrix(91 0 0 -112 980 121464)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A3B5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A4C3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "680.59 140.53 569 100.03 637.67 237.49",
    fill: "url(#wa)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wb",
    x1: -5.6885,
    x2: -4.4619,
    y1: 1085.4,
    y2: 1084.2,
    gradientTransform: "matrix(75 0 0 -59 1024 64283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2662AF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2487BA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "637.67 237.49 603.33 309.9 695.3 255.9",
    fill: "url(#wb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wc",
    x1: -9.4409,
    x2: -8.2139,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(47 0 0 -94 1080 102039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B0CA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2396BF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "695.3 255.9 680.59 140.53 637.67 237.49",
    fill: "url(#wc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wd",
    x1: -4.4263,
    x2: -3.1995,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(97 0 0 -81 823 88173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#380E8B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32119C",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "502.78 370.04 383.83 436.32 447.59 469.46",
    fill: "url(#wd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "we",
    x1: -5.4219,
    x2: -4.195,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(82 0 0 -96 935 104292)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A438E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31349D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "603.33 309.9 510.14 252.22 502.78 370.04",
    fill: "url(#we)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wf",
    x1: -5.0825,
    x2: -3.8558,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(82 0 0 -127 935 137850)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A19AE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2CA3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "603.33 309.9 502.78 370.04 597.2 465.78",
    fill: "url(#wf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wg",
    x1: -4.6304,
    x2: -3.4033,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(100 0 0 -113 726 122590)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#533E67",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4666",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "369.11 155.26 268.56 293.95 391.18 273.08",
    fill: "url(#wg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wh",
    x1: -4.3066,
    x2: -3.0798,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(100 0 0 -133 726 144306)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A2E67",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E216F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "391.18 273.08 268.56 293.95 383.83 436.32",
    fill: "url(#wh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wi",
    x1: -9.7891,
    x2: -8.5626,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(50 0 0 -96 858 104213)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5565",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774767",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "430.43 201.9 369.11 155.26 391.18 273.08",
    fill: "url(#wi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wk",
    x1: -4.7104,
    x2: -3.4837,
    y1: 1082.8,
    y2: 1081.5,
    gradientTransform: "matrix(97 0 0 -133 823 144306)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40147F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482280",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "391.18 273.08 383.83 436.32 502.78 370.04",
    fill: "url(#wk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wl",
    x1: -4.7197,
    x2: -3.4929,
    y1: 1085.5,
    y2: 1084.3,
    gradientTransform: "matrix(97 0 0 -58 829 63173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D4C6C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664274",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "510.14 252.22 430.43 201.9 391.18 273.08",
    fill: "url(#wl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wm",
    x1: -4.2617,
    x2: -3.0349,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(97 0 0 -96 829 104292)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44268C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3C79",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "502.78 370.04 510.14 252.22 391.18 273.08",
    fill: "url(#wm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wn",
    x1: -8.3281,
    x2: -7.1011,
    y1: 1084.8,
    y2: 1083.6,
    gradientTransform: "matrix(58 0 0 -79 828.97 85757)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896766",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#916664",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "414.48 79.164 343.36 58.298 369.11 155.26",
    fill: "url(#wn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wo",
    x1: -5.627,
    x2: -4.4005,
    y1: 1084.2,
    y2: 1083,
    gradientTransform: "matrix(83 0 0 -96 804 104055)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#936864",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A96A5F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "414.48 79.164 435.08 0 404.56 0 343.36 58.298",
    fill: "url(#wo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp",
    x1: -9.7412,
    x2: -8.5145,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(50 0 0 -100 858 108475)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895F65",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946166",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "430.43 201.9 414.48 79.164 369.11 155.26",
    fill: "url(#wp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wr",
    x1: -6.1987,
    x2: -4.9721,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(74 0 0 -100 871 108475)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90626B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977672",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "505.23 112.3 414.48 79.164 430.43 201.9",
    fill: "url(#wr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ws",
    x1: -6.332,
    x2: -5.1052,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(74 0 0 -123 871 133242)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE7063",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B7871",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "505.23 112.3 460.53 0 435.08 0 414.48 79.164",
    fill: "url(#ws)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wt",
    x1: -8.8613,
    x2: -7.635,
    y1: 1083.3,
    y2: 1082,
    gradientTransform: "matrix(53 0 0 -109 919 118441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E0CA7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3011AB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "512.59 503.82 502.78 370.04 447.59 469.46",
    fill: "url(#wt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wu",
    x1: -5.8662,
    x2: -4.6396,
    y1: 1083,
    y2: 1081.8,
    gradientTransform: "matrix(77 0 0 -109 940 118441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E15A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E0EB7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "597.2 465.78 502.78 370.04 512.59 503.82",
    fill: "url(#wu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ww",
    x1: -3.9229,
    x2: -2.696,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(101 0 0 -164 924 177974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E0FC0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C11CD",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "512.59 503.82 636.44 667.06 597.2 465.78",
    fill: "url(#ww)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wx",
    x1: -4.5562,
    x2: -3.3296,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(90 0 0 -128 991 139313)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E443E5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F360E8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "581.26 778.75 624.18 935.85 691.62 841.34",
    fill: "url(#wx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wy",
    x1: -4.4297,
    x2: -3.203,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(90 0 0 -108 991 117636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E237E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE43E7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "581.26 778.75 691.62 841.34 684.27 708.79",
    fill: "url(#wy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wz",
    x1: -8.1523,
    x2: -6.9256,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(53 0 0 -108 1112 117636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED37E7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54EE7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "684.27 708.79 691.62 841.34 749.26 759.11",
    fill: "url(#wz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xa",
    x1: -4.458,
    x2: -3.2311,
    y1: 1082.9,
    y2: 1081.6,
    gradientTransform: "matrix(89 0 0 -88 1082 96057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F753E6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F865E6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "691.62 841.34 800.76 867.11 749.26 759.11",
    fill: "url(#xa)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xb",
    x1: -2.5776,
    x2: -1.351,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(98 0 0 -156 1630 169284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1296C7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D9ECE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1374.7 527.14 1494.8 605.69 1456.8 414.23",
    fill: "url(#xb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xc",
    x1: -4.7197,
    x2: -3.4927,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(60 0 0 -103 1706 1.1189e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1799D5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13B3DD",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1494.8 338.13 1421.3 287.81 1456.8 414.23",
    fill: "url(#xc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xd",
    x1: -2.4082,
    x2: -1.1813,
    y1: 1084.8,
    y2: 1083.6,
    gradientTransform: "matrix(106 0 0 -62 1689 67608)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12BCE1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11C4E1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1456.8 414.23 1586.8 413 1494.8 338.13",
    fill: "url(#xd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xe",
    x1: -3.6646,
    x2: -2.4379,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(75 0 0 -156 1720 169284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A95C9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CABD4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1494.8 605.69 1548.8 589.74 1456.8 414.23",
    fill: "url(#xe)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xf",
    x1: -1.9746,
    x2: -0.7477,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(106 0 0 -144 1689 156311)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CB0D6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11C5E0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1548.8 589.74 1586.8 413 1456.8 414.23",
    fill: "url(#xf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xh",
    x1: -2.6143,
    x2: -1.3869,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(76 0 0 -109 2069 118674)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0581",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22057F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1886 789.79 1924 788.29 1924 671.32 1916.7 656.01",
    fill: "url(#xh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xi",
    x1: -3.7222,
    x2: -2.4951,
    y1: 1083.1,
    y2: 1081.8,
    gradientTransform: "matrix(56 0 0 -95 2100 103445)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D158D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120A82",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1916.7 656.01 1924 642.51 1924 547.3 1899.5 539.42",
    fill: "url(#xi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xj",
    x1: -2.2881,
    x2: -1.061,
    y1: 1083,
    y2: 1081.8,
    gradientTransform: "matrix(88 0 0 -97 2068 105528)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B1582",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0B69",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 547.3 1924 517.38 1899.5 539.42",
    fill: "url(#xj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xk",
    x1: -4.1709,
    x2: -2.9444,
    y1: 1081.9,
    y2: 1080.7,
    gradientTransform: "matrix(51 0 0 -183 2119 198591)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180785",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#220576",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1924 671.32 1924 642.51 1916.7 656.01",
    fill: "url(#xk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xl",
    x1: -5.7715,
    x2: -4.5448,
    y1: 1082.8,
    y2: 1081.5,
    gradientTransform: "matrix(83 0 0 -104 806 113189)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C0F7D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610F91",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "365.43 685.47 447.59 676.88 345.81 557.83",
    fill: "url(#xl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xm",
    x1: -6.769,
    x2: -5.5422,
    y1: 1083.2,
    y2: 1081.9,
    gradientTransform: "matrix(67 0 0 -98 837.97 1.068e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69118A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7013A8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "446.37 797.16 447.59 676.88 365.43 685.47",
    fill: "url(#xm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xn",
    x1: -4.0308,
    x2: -2.804,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(110 0 0 -98 861 106800)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F19B9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1DC8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "446.37 797.16 581.26 778.75 447.59 676.88",
    fill: "url(#xn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xo",
    x1: -2.189,
    x2: -0.9622,
    y1: 1083.3,
    y2: 1082,
    gradientTransform: "matrix(154 0 0 -91 818 99225)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C225DF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B16CF",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "447.59 676.88 581.26 778.75 636.44 667.06",
    fill: "url(#xo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xp",
    x1: -3.71,
    x2: -2.4828,
    y1: 1083.5,
    y2: 1082.2,
    gradientTransform: "matrix(116 0 0 -90 773 97983)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D0D89",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B0AAC",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "447.59 469.46 345.81 557.83 488.06 579.92",
    fill: "url(#xp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xq",
    x1: -3.5205,
    x2: -2.2936,
    y1: 1083.3,
    y2: 1082.1,
    gradientTransform: "matrix(116 0 0 -97 773 105622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#540E8B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F0CB2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "345.81 557.83 447.59 676.88 488.06 579.92",
    fill: "url(#xq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xu",
    x1: -8.7998,
    x2: -7.573,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(53 0 0 -90 919 97983)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#320AAD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#380ABC",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "488.06 579.92 512.59 503.82 447.59 469.46",
    fill: "url(#xu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xv",
    x1: -2.647,
    x2: -1.4202,
    y1: 1083.3,
    y2: 1082.1,
    gradientTransform: "matrix(154 0 0 -79 818 86182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#670FC1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D11D1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "447.59 676.88 636.44 667.06 488.06 579.92",
    fill: "url(#xv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xw",
    x1: -3.3647,
    x2: -2.1378,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(121 0 0 -133 884 144494)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440CC6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7510D0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "488.06 579.92 636.44 667.06 512.59 503.82",
    fill: "url(#xw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xx",
    x1: -6.5078,
    x2: -5.2811,
    y1: 1083.6,
    y2: 1082.3,
    gradientTransform: "matrix(77 0 0 -74 683 80809)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0433B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3543",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "221.96 619.19 187.62 710.02 282.05 641.28",
    fill: "url(#xx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xy",
    x1: -4.6035,
    x2: -3.3768,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(100 0 0 -149 660 161902)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C13A3D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94214E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "282.05 641.28 187.62 710.02 310.25 824.16",
    fill: "url(#xy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xz",
    x1: -4.5244,
    x2: -3.2979,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(101 0 0 -68 687 74273)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63146",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B1D59",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "345.81 557.83 221.96 619.19 282.05 641.28",
    fill: "url(#xz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ya",
    x1: -7.1313,
    x2: -5.9041,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(68 0 0 -149 768.97 1.619e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781659",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#861A5F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "282.05 641.28 310.25 824.16 365.43 685.47",
    fill: "url(#ya)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yb",
    x1: -7.127,
    x2: -5.9005,
    y1: 1083,
    y2: 1081.8,
    gradientTransform: "matrix(68 0 0 -104 768.9688 113189)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B146A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#821A63",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "345.81 557.83 282.05 641.28 365.43 685.47",
    fill: "url(#yb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yc",
    x1: -8.8848,
    x2: -7.6582,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(56 0 0 -95 804 103677)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#631364",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58127B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "321.29 940.76 378.92 868.34 310.25 824.16",
    fill: "url(#yc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yd",
    x1: -3.7983,
    x2: -2.5714,
    y1: 1084,
    y2: 1082.7,
    gradientTransform: "matrix(111 0 0 -58 749 63658)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C146C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#751691",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "310.25 824.16 378.92 868.34 446.37 797.16",
    fill: "url(#yd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yf",
    x1: -2.2339,
    x2: -1.0071,
    y1: 1082.4,
    y2: 1081.1,
    gradientTransform: "matrix(169 0 0 -114 747 124194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9920B6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA33B9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "378.92 868.34 586.16 937.07 446.37 797.16",
    fill: "url(#yf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yg",
    x1: -6.311,
    x2: -5.0838,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(81 0 0 -90 615 98179)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C13834",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C13B37",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "187.62 710.02 109.14 820.48 208.47 803.29",
    fill: "url(#yg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yh",
    x1: -4.9229,
    x2: -3.696,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(100 0 0 -93 660 101422)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF393A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#932246",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "187.62 710.02 208.47 803.29 310.25 824.16",
    fill: "url(#yh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yi",
    x1: -5.6855,
    x2: -4.4587,
    y1: 1082.1,
    y2: 1080.9,
    gradientTransform: "matrix(72 0 0 -149 1044 1.6214e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16BE9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC63E5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "624.18 935.85 651.56 1080 666.38 1080 712.47 927.26",
    fill: "url(#yi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yj",
    x1: -5.9043,
    x2: -4.6773,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(72 0 0 -77 1044 84233)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46DE8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76DE7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "624.18 935.85 712.47 927.26 691.62 841.34",
    fill: "url(#yj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yk",
    x1: -2.916,
    x2: -1.6892,
    y1: 1081.8,
    y2: 1080.6,
    gradientTransform: "matrix(128 0 0 -149 1015 162135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E753E3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F25FE5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "712.47 927.26 666.38 1080 724.89 1080 814.25 1040.2",
    fill: "url(#yk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yl",
    x1: -4.4204,
    x2: -3.1939,
    y1: 1083.2,
    y2: 1081.9,
    gradientTransform: "matrix(89 0 0 -70 1082 76666)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86AE6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F872E5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "691.62 841.34 712.47 927.26 800.76 867.11",
    fill: "url(#yl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ym",
    x1: -2.8506,
    x2: -1.6239,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(123 0 0 -92 1065 100469)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96FE3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F665E3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "712.47 927.26 863.3 980.03 800.76 867.11",
    fill: "url(#ym)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yn",
    x1: -2.8027,
    x2: -1.5757,
    y1: 1082.6,
    y2: 1081.3,
    gradientTransform: "matrix(123 0 0 -92 1065 100518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F154E4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F460E4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "814.25 1040.2 863.3 980.03 712.47 927.26",
    fill: "url(#yn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yo",
    x1: -11.079,
    x2: -9.8521,
    y1: 1082.2,
    y2: 1081,
    gradientTransform: "matrix(41 0 0 -126 1034 137279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65FE5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E45BE3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "573.9 975.12 593.97 1080 597.89 1080 624.18 935.85",
    fill: "url(#yo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yq",
    x1: -9.0435,
    x2: -7.8164,
    y1: 1081.9,
    y2: 1080.6,
    gradientTransform: "matrix(50 0 0 -142 1043 154575)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB62E7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4EE1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "597.89 1080 651.56 1080 624.18 935.85",
    fill: "url(#yq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yr",
    x1: -5.6621,
    x2: -4.4355,
    y1: 1083,
    y2: 1081.7,
    gradientTransform: "matrix(84 0 0 -65 785 71342)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49138D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#571AA6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "353.17 1020.5 424.29 1002.1 321.29 940.76",
    fill: "url(#yr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yt",
    x1: -5.5161,
    x2: -4.2893,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(84 0 0 -109 785 118847)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#511489",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B1B9D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "321.29 940.76 424.29 1002.1 378.92 868.34",
    fill: "url(#yt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yu",
    x1: -8.083,
    x2: -6.8564,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(58 0 0 -120 836.9688 130847)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4617A5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#551CAC",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "353.17 1020.5 379.77 1080 417.16 1080 424.29 1002.1",
    fill: "url(#yu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yv",
    x1: -2.2695,
    x2: -1.0429,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(169 0 0 -109 747 118847)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8922A5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF3CCB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "378.92 868.34 424.29 1002.1 586.16 937.07",
    fill: "url(#yv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yw",
    x1: -2.5586,
    x2: -1.3319,
    y1: 1082,
    y2: 1080.8,
    gradientTransform: "matrix(151 0 0 -120 791 130847)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6322B2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E35C9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "417.16 1080 575.59 1080 424.29 1002.1",
    fill: "url(#yw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yx",
    x1: -3.0063,
    x2: -1.7785,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(132 0 0 -53 821 58367)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC54E0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD45D3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "424.29 1002.1 573.9 975.12 586.16 937.07",
    fill: "url(#yx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yy",
    x1: -2.5815,
    x2: -1.355,
    y1: 1082.6,
    y2: 1081.3,
    gradientTransform: "matrix(140 0 0 -94 813 102719)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D854E0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B33ED0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "424.29 1002.1 575.59 1080 593.97 1080 573.9 975.12",
    fill: "url(#yy)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yz",
    x1: -9.0542,
    x2: -7.8282,
    y1: 1082.4,
    y2: 1081.1,
    gradientTransform: "matrix(55 0 0 -98 751 107102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0473",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#210782",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "253.88 1080 306.74 1080 257.52 1047.5",
    fill: "url(#yz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "za",
    x1: -6.0005,
    x2: -4.7736,
    y1: 1083.6,
    y2: 1082.3,
    gradientTransform: "matrix(78 0 0 -51 739 56273)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#250884",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D0C93",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "257.52 1047.5 306.74 1080 313.56 1080 353.17 1020.5",
    fill: "url(#za)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zc",
    x1: -5.792,
    x2: -4.5651,
    y1: 1082.2,
    y2: 1080.9,
    gradientTransform: "matrix(81 0 0 -105 780 114647)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37129D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F0F99",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "313.56 1080 379.77 1080 353.17 1020.5",
    fill: "url(#zc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zd",
    x1: -1.3403,
    x2: -0.1133,
    y1: 1083.8,
    y2: 1082.6,
    gradientTransform: "matrix(142 0 0 -109 1602.9 1.1821e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D5FCC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413FC1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1464.2 217.85 1569.6 84.073 1395.5 155.26",
    fill: "url(#zd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ze",
    x1: -2.4146,
    x2: -1.1876,
    y1: 1085.5,
    y2: 1084.3,
    gradientTransform: "matrix(113 0 0 -58 1540 63185)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4764A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B66B7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1345.2 216.62 1282.7 280.45 1421.3 287.81",
    fill: "url(#ze)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zf",
    x1: -2.8711,
    x2: -1.644,
    y1: 1086.4,
    y2: 1085.1,
    gradientTransform: "matrix(97 0 0 -51 1607 55568)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3544B5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C58BB",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1464.2 217.85 1395.5 155.26 1345.2 216.62",
    fill: "url(#zf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zg",
    x1: -2.5073,
    x2: -1.2804,
    y1: 1085.9,
    y2: 1084.6,
    gradientTransform: "matrix(97 0 0 -58 1607 63185)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F77C9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2961BE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1421.3 287.81 1464.2 217.85 1345.2 216.62",
    fill: "url(#zg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zh",
    x1: -3.1577,
    x2: -1.9307,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(96 0 0 -129 1507 139781)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C367C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362388",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1339.1 125.8 1269.2 26.388 1221.4 184.72",
    fill: "url(#zh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zi",
    x1: -5.4019,
    x2: -4.175,
    y1: 1084.9,
    y2: 1083.7,
    gradientTransform: "matrix(57 0 0 -81 1585 87893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341B86",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412194",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1337.9 79.164 1269.2 26.388 1339.1 125.8",
    fill: "url(#zi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zj",
    x1: -6.8906,
    x2: -5.6641,
    y1: 1084.8,
    y2: 1083.6,
    gradientTransform: "matrix(46 0 0 -74 1653 80407)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3841A6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C33A4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1395.5 155.26 1339.1 125.8 1345.2 216.62",
    fill: "url(#zj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zk",
    x1: -10.527,
    x2: -9.3005,
    y1: 1088.5,
    y2: 1087.3,
    gradientTransform: "matrix(32 0 0 -38 1666 41453)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#442199",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43289E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1377.1 122.12 1337.9 79.164 1339.1 125.8",
    fill: "url(#zk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zl",
    x1: -0.7627,
    x2: 0.4642,
    y1: 1083.9,
    y2: 1082.7,
    gradientTransform: "matrix(204 0 0 -108 1494 117050)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#571EA6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#641DB2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1377.1 122.12 1571.4 0 1558.9 0 1337.9 79.164",
    fill: "url(#zl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zn",
    x1: -6.6519,
    x2: -5.4252,
    y1: 1091.8,
    y2: 1090.6,
    gradientTransform: "matrix(46 0 0 -27 1653 29597)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#402B9E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4031A9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1395.5 155.26 1377.1 122.12 1339.1 125.8",
    fill: "url(#zn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zo",
    x1: -1.2183,
    x2: 0.0088,
    y1: 1086.1,
    y2: 1084.9,
    gradientTransform: "matrix(157 0 0 -58 1573 63077)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4338B7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B32BA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1569.6 84.073 1377.1 122.12 1395.5 155.26",
    fill: "url(#zo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zp",
    x1: -1.0796,
    x2: 0.1477,
    y1: 1083.9,
    y2: 1082.6,
    gradientTransform: "matrix(172 0 0 -108 1558 117050)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E2FC8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6521B7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1569.6 84.073 1586 0 1571.4 0 1377.1 122.12",
    fill: "url(#zp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zq",
    x1: -5.3779,
    x2: -4.1511,
    y1: 1084.7,
    y2: 1083.5,
    gradientTransform: "matrix(58 0 0 -78 1545 84779)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4980",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565290",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1292.5 204.35 1221.4 184.72 1282.7 280.45",
    fill: "url(#zq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zr",
    x1: -2.8989,
    x2: -1.6724,
    y1: 1085.6,
    y2: 1084.3,
    gradientTransform: "matrix(96 0 0 -64 1507 69597)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523E7F",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44368F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1339.1 125.8 1221.4 184.72 1292.5 204.35",
    fill: "url(#zr)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zs",
    x1: -6.311,
    x2: -5.0845,
    y1: 1085.3,
    y2: 1084.1,
    gradientTransform: "matrix(51 0 0 -62 1602 67499)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525B9A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424A9A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1292.5 204.35 1282.7 280.45 1345.2 216.62",
    fill: "url(#zs)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zu",
    x1: -7.564,
    x2: -6.3377,
    y1: 1084.9,
    y2: 1083.7,
    gradientTransform: "matrix(43 0 0 -74 1618 80407)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3298",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E439A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1345.2 216.62 1339.1 125.8 1292.5 204.35",
    fill: "url(#zu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zv",
    x1: -4.3052,
    x2: -3.0783,
    y1: 1086.1,
    y2: 1084.8,
    gradientTransform: "matrix(73 0 0 -46 1550 50351)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7295A7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5795B0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.2 386 1245.9 419.14 1335.4 442.46",
    fill: "url(#zv)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zw",
    x1: -4.9194,
    x2: -3.6927,
    y1: 1084.4,
    y2: 1083.2,
    gradientTransform: "matrix(63 0 0 -72 1570 78431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6693AB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4692B5",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1293.7 354.09 1258.2 386 1335.4 442.46",
    fill: "url(#zw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zx",
    x1: -2.4424,
    x2: -1.2154,
    y1: 1083.1,
    y2: 1081.9,
    gradientTransform: "matrix(104 0 0 -126 1558 136751)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#408EB8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2691C6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1335.4 442.46 1421.3 287.81 1293.7 354.09",
    fill: "url(#zx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zz",
    x1: -2.5444,
    x2: -1.3175,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(99 0 0 -92 1597 100100)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1796C5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CA8CE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1335.4 442.46 1374.7 527.14 1456.8 414.23",
    fill: "url(#zz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaa",
    x1: -2.7329,
    x2: -1.5059,
    y1: 1083,
    y2: 1081.7,
    gradientTransform: "matrix(99 0 0 -126 1597 136751)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A95D1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA8D0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1456.8 414.23 1421.3 287.81 1335.4 442.46",
    fill: "url(#aaa)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aab",
    x1: -4.5156,
    x2: -3.2887,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(72 0 0 -97 1526 1.0551e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7891",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6385A1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1303.5 528.37 1245.9 419.14 1215.2 538.19",
    fill: "url(#aab)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aac",
    x1: -4.0337,
    x2: -2.8067,
    y1: 1083.7,
    y2: 1082.5,
    gradientTransform: "matrix(73 0 0 -89 1550 96861)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6694A9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#388BB2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1335.4 442.46 1245.9 419.14 1303.5 528.37",
    fill: "url(#aac)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aad",
    x1: -3.5361,
    x2: -2.3083,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(82 0 0 -125 1564 135865)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49368E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A70AA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1274.1 680.56 1374.7 527.14 1303.5 528.37",
    fill: "url(#aad)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aae",
    x1: -5.4873,
    x2: -4.2602,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(58 0 0 -70 1612 76341)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2893BC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2682B4",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1303.5 528.37 1374.7 527.14 1335.4 442.46",
    fill: "url(#aae)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaf",
    x1: -4.2295,
    x2: -3.0024,
    y1: 1084.5,
    y2: 1083.2,
    gradientTransform: "matrix(72 0 0 -63 1526 68844)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786689",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575B91",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1239.8 605.69 1303.5 528.37 1215.2 538.19",
    fill: "url(#aaf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aag",
    x1: -6.1221,
    x2: -4.8954,
    y1: 1082.9,
    y2: 1081.6,
    gradientTransform: "matrix(52 0 0 -124 1566 134785)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592C84",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51508F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1239.8 605.69 1274.1 680.56 1303.5 528.37",
    fill: "url(#aag)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aah",
    x1: -2.9961,
    x2: -1.7692,
    y1: 1083.3,
    y2: 1082.1,
    gradientTransform: "matrix(102 0 0 -89 1414 96958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B43E81",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#885080",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1215.2 538.19 1114.7 647.42 1239.8 605.69",
    fill: "url(#aah)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aai",
    x1: -2.0181,
    x2: -0.7913,
    y1: 1084.3,
    y2: 1083.1,
    gradientTransform: "matrix(130 0 0 -61 1386 66745)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA2F83",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#732B80",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1114.7 647.42 1274.1 680.56 1239.8 605.69",
    fill: "url(#aai)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aak",
    x1: -3.8506,
    x2: -2.6236,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(89 0 0 -65 1338 71038)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64A94",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB5184",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1005.6 641.28 1114.7 647.42 1065.6 567.64",
    fill: "url(#aak)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aal",
    x1: -2.2637,
    x2: -1.0366,
    y1: 1083.5,
    y2: 1082.2,
    gradientTransform: "matrix(122 0 0 -89 1354 96958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA4780",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1687E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1065.6 567.64 1114.7 647.42 1215.2 538.19",
    fill: "url(#aal)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aam",
    x1: -2.5156,
    x2: -1.2887,
    y1: 1084.3,
    y2: 1083.1,
    gradientTransform: "matrix(122 0 0 -64 1354 69893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D58B7C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3747E",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1065.6 567.64 1215.2 538.19 1141.7 489.1",
    fill: "url(#aam)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aan",
    x1: -2.625,
    x2: -1.398,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(122 0 0 -143 1185 155263)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46B7B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1738B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "858.4 486.64 884.15 629.01 1008 453.5",
    fill: "url(#aan)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aao",
    x1: -2.7266,
    x2: -1.4992,
    y1: 1084,
    y2: 1082.8,
    gradientTransform: "matrix(122 0 0 -78 1185 84947)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E58276",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A775",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1008 453.5 984.71 390.91 858.4 486.64",
    fill: "url(#aao)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aap",
    x1: -3.374,
    x2: -2.1478,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(101 0 0 -153 1227 166073)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1539D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17289",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "884.15 629.01 1005.6 641.28 1008 453.5",
    fill: "url(#aap)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaq",
    x1: -4.4487,
    x2: -3.2217,
    y1: 1084.5,
    y2: 1083.3,
    gradientTransform: "matrix(77 0 0 -70 1333 76280)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4AF79",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4AD79",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1079.1 367.59 984.71 390.91 1008 453.5",
    fill: "url(#aaq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aar",
    x1: -7.7876,
    x2: -6.561,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(49 0 0 -153 1378 166073)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED618D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF8779",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1008 453.5 1005.6 641.28 1065.6 567.64",
    fill: "url(#aar)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aas",
    x1: -2.8262,
    x2: -1.5993,
    y1: 1083.5,
    y2: 1082.2,
    gradientTransform: "matrix(109 0 0 -93 1320 101213)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB8678",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA9E78",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1141.7 489.1 1008 453.5 1065.6 567.64",
    fill: "url(#aas)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aat",
    x1: -2.9165,
    x2: -1.6895,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(109 0 0 -99 1320 107629)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AD7B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA579",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1079.1 367.59 1008 453.5 1141.7 489.1",
    fill: "url(#aat)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaw",
    x1: -8.0337,
    x2: -6.8063,
    y1: 1084.1,
    y2: 1082.8,
    gradientTransform: "matrix(55 0 0 -79 1039 86010)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D18B0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E28A8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "664.65 368.82 597.2 465.78 659.74 452.28",
    fill: "url(#aaw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aax",
    x1: -5.4365,
    x2: -4.2098,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(75 0 0 -163 1019 176882)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4512B9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7719C0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "597.2 465.78 689.17 652.33 659.74 452.28",
    fill: "url(#aax)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aay",
    x1: -5.8906,
    x2: -4.6638,
    y1: 1084.3,
    y2: 1083.1,
    gradientTransform: "matrix(73 0 0 -68 1072 74119)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F36A2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#472F9D",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "749.26 435.09 664.65 368.82 659.74 452.28",
    fill: "url(#aay)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaz",
    x1: -5.7969,
    x2: -4.5698,
    y1: 1082.4,
    y2: 1081.2,
    gradientTransform: "matrix(71 0 0 -163 1074 1.7688e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A91BC8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B20A7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "659.74 452.28 689.17 652.33 746.81 495.23",
    fill: "url(#aaz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aba",
    x1: -5.4282,
    x2: -4.2014,
    y1: 1085.9,
    y2: 1084.7,
    gradientTransform: "matrix(73 0 0 -49 1072 53634)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#732B99",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#532D9B",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "746.81 495.23 749.26 435.09 659.74 452.28",
    fill: "url(#aba)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abb",
    x1: -2.7188,
    x2: -1.4919,
    y1: 1089.3,
    y2: 1088.1,
    gradientTransform: "matrix(85 0 0 -23 1876 25681)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056DC7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0556C1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1666.5 641.28 1764.6 651.1 1660.4 622.88",
    fill: "url(#abb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abc",
    x1: -2.6074,
    x2: -1.3805,
    y1: 1083.3,
    y2: 1082,
    gradientTransform: "matrix(85 0 0 -90 1876 98041)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0576CA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066DC7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1764.6 651.1 1714.3 540.64 1660.4 622.88",
    fill: "url(#abc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abd",
    x1: -2.6997,
    x2: -1.4725,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(80 0 0 -148 1886 160821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064CBC",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B27A9",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1686.1 822.93 1764.6 651.1 1666.5 641.28",
    fill: "url(#abd)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abe",
    x1: -1.0352,
    x2: 0.1918,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(124 0 0 -113 1922 122994)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#150B8E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1CA0",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1886 789.79 1916.7 656.01 1764.6 651.1",
    fill: "url(#abe)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abf",
    x1: -1.291,
    x2: -0.0639,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(124 0 0 -95 1922 103445)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1D9B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C20A2",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1916.7 656.01 1899.5 539.42 1764.6 651.1",
    fill: "url(#abf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abh",
    x1: -3.8501,
    x2: -2.6233,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(62 0 0 -69 1943 75271)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0796D2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0687CD",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1790.4 534.51 1749.9 455.96 1714.3 540.64",
    fill: "url(#abh)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abi",
    x1: -3.4854,
    x2: -2.2584,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(62 0 0 -95 1943 1.0344e5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0682CD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0658C1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1790.4 534.51 1714.3 540.64 1764.6 651.1",
    fill: "url(#abi)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abj",
    x1: -1.5347,
    x2: -0.3079,
    y1: 1084.1,
    y2: 1082.9,
    gradientTransform: "matrix(122 0 0 -68 1912 74190)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#067EC9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0749B1",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1899.5 539.42 1749.9 455.96 1790.4 534.51",
    fill: "url(#abj)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abk",
    x1: -1.5713,
    x2: -0.345,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(110 0 0 -95 1936 103441)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#073DB6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0740AE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1764.6 651.1 1899.5 539.42 1790.4 534.51",
    fill: "url(#abk)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abl",
    x1: -2.4521,
    x2: -1.2251,
    y1: 1082.9,
    y2: 1081.7,
    gradientTransform: "matrix(82 0 0 -92 1900 100418)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16088B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#200685",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1686.1 822.93 1737.6 917.44 1786.7 804.52",
    fill: "url(#abl)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abm",
    x1: -2.6772,
    x2: -1.45,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(82 0 0 -140 1900 152181)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F98",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1EA3",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1786.7 804.52 1764.6 651.1 1686.1 822.93",
    fill: "url(#abm)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abn",
    x1: -2.7764,
    x2: -1.5493,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(79 0 0 -92 1945 100418)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D037B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#260580",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1737.6 917.44 1834.5 913.75 1786.7 804.52",
    fill: "url(#abn)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abo",
    x1: -2.0635,
    x2: -0.8366,
    y1: 1082.3,
    y2: 1081.1,
    gradientTransform: "matrix(99 0 0 -125 1947 135966)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A25AA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#130A8F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1786.7 804.52 1886 789.79 1764.6 651.1",
    fill: "url(#abo)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abp",
    x1: -2.2773,
    x2: -1.0502,
    y1: 1082.8,
    y2: 1081.5,
    gradientTransform: "matrix(81 0 0 -101 1983 110135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C047A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#190786",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1834.5 913.75 1886 789.79 1786.7 804.52",
    fill: "url(#abp)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abq",
    x1: -4.1226,
    x2: -2.8953,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(82 0 0 -71 1300 77905)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF12D1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D00FCE",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "982.59 1080 1040.7 1080 1016.6 1035.3",
    fill: "url(#abq)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abs",
    x1: -2.6484,
    x2: -1.4216,
    y1: 1083.2,
    y2: 1082,
    gradientTransform: "matrix(117 0 0 -52 1319 57366)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40ECE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0AC8",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1016.6 1035.3 1040.7 1080 1150.7 1080 1160.1 1078.2",
    fill: "url(#abs)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abt",
    x1: -3.062,
    x2: -1.8341,
    y1: 1083.2,
    y2: 1081.9,
    gradientTransform: "matrix(89 0 0 -70 1375 76859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA07BE",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C809C6",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1150.7 1080 1159.5 1080 1160.1 1078.2",
    fill: "url(#abt)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abu",
    x1: -1.2373,
    x2: -0.0118,
    y1: 1082.6,
    y2: 1081.4,
    gradientTransform: "matrix(172 0 0 -73 1357 80102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC07C0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C408C7",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1159.5 1080 1163.7 1080 1160.1 1078.2",
    fill: "url(#abu)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abw",
    x1: -1.4458,
    x2: -0.2194,
    y1: 1082.7,
    y2: 1081.5,
    gradientTransform: "matrix(148 0 0 -73 1405 80102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D20BCB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB0BCA",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1163.7 1080 1287.4 1080 1160.1 1078.2",
    fill: "url(#abw)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abx",
    x1: -4.1216,
    x2: -2.8947,
    y1: 1083.8,
    y2: 1082.5,
    gradientTransform: "matrix(116 0 0 -50 637 55080)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D0D54",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F1060",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "179.04 944.44 321.29 940.76 241.58 883.07",
    fill: "url(#abx)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aby",
    x1: -5.8311,
    x2: -4.604,
    y1: 1083.5,
    y2: 1082.3,
    gradientTransform: "matrix(83 0 0 -65 694 71230)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#912141",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D154F",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "310.25 824.16 208.47 803.29 241.58 883.07",
    fill: "url(#aby)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "abz",
    x1: -7.5425,
    x2: -6.316,
    y1: 1082.8,
    y2: 1081.5,
    gradientTransform: "matrix(65 0 0 -95 738.9688 103677)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61125A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#541161",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "241.58 883.07 321.29 940.76 310.25 824.16",
    fill: "url(#abz)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aca",
    x1: -6.1704,
    x2: -4.9431,
    y1: 1083.6,
    y2: 1082.4,
    gradientTransform: "matrix(81 0 0 -63 615 69068)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B32E36",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1253A",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "208.47 803.29 109.14 820.48 133.66 880.62",
    fill: "url(#aca)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acb",
    x1: -5.5,
    x2: -4.273,
    y1: 1084,
    y2: 1082.7,
    gradientTransform: "matrix(88 0 0 -52 628 57240)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E0F4B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#731545",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "133.66 880.62 179.04 944.44 241.58 883.07",
    fill: "url(#acb)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acc",
    x1: -5.7041,
    x2: -4.477,
    y1: 1083.4,
    y2: 1082.2,
    gradientTransform: "matrix(88 0 0 -65 628 71230)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99243D",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E1943",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "208.47 803.29 133.66 880.62 241.58 883.07",
    fill: "url(#acc)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acf",
    x1: -6.4033,
    x2: -5.1761,
    y1: 1082.5,
    y2: 1081.3,
    gradientTransform: "matrix(82 0 0 -102 552 111241)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951441",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22339",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "109.14 820.48 33.11 945.67 133.66 880.62",
    fill: "url(#acf)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acg",
    x1: -6.2725,
    x2: -5.046,
    y1: 1083,
    y2: 1081.8,
    gradientTransform: "matrix(82 0 0 -76 552 83184)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A0E46",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#891144",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "133.66 880.62 33.11 945.67 51.504 973.89",
    fill: "url(#acg)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ach",
    x1: -4.8555,
    x2: -3.6284,
    y1: 1082.8,
    y2: 1081.6,
    gradientTransform: "matrix(104 0 0 -76 545 83184)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0C49",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711246",
    offset: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "51.504 973.89 179.04 944.44 133.66 880.62",
    fill: "url(#ach)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangles);
export default __webpack_public_path__ + "static/media/triangles.38ef0e49606e3c37ea567e831910e4a0.svg";
export { ForwardRef as ReactComponent };